module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Disagreeing Virtuously: Religious Conflict in Interdisciplinary Perspective")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch001"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch001"
    }
  }, [_vm._v("We Have Been Here Before")])]), _vm._v(" "), _c('p', {
    staticClass: "CE"
  }, [_vm._v("But what differences are there which cannot be thus decided, and which therefore make us angry and set us at enmity with one another? I dare say the answer does not occur to you at the moment, and therefore I will suggest that these enmities arise when the matters of difference are the just and unjust, good and evil, honorable and dishonorable. Are not these the points about which men differ, and about which when we are unable satisfactorily to decide our differences, you and I and all of us quarrel, when we do quarrel?")]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("Plato, "), _c('i', [_vm._v("Euthyphro")]), _vm._v(" 7")]), _vm._v(" "), _c('p', {
    staticClass: "CE"
  }, [_vm._v("For human reason is very deficient in things concerning God. A sign of this is that philosophers in their researches, by natural investigation, into human affairs, have fallen into many errors, and have disagreed among themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("St. Thomas Aquinas, "), _c('i', [_vm._v("ST")]), _vm._v(" II-IIae.2.4")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The first philosophical writings that have been preserved for us give mutually conflicting accounts of the nature of ultimate reality and the possibility of knowledge. Although history does not offer consensus, there are multiple lessons to be drawn from the writings of our predecessors. The philosophical problem of disagreement has been with us from the beginning, and over the centuries we have tried to solve the problem in myriad ways, some of which I will summarize in the following pages. Against this background, we may come to understand our own disagreements and proposed solutions more clearly.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("1.1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Malleable Men and the Council of the Wise: Plato and Aristotle")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("One of the first philosophical treatises from the pre-Socratic period comes from Parmenides of Elea (515–445 BC), whose "), _c('i', [_vm._v("Poem")]), _vm._v(" focuses on the opinions of simple men who are misled by naively following their senses. Because the world of senses is in a constant state of flux, we are not able to form correct opinions about what is and what is not and we are therefore doomed to form contradictory convictions. Philosophers, instead, know a better way: the meditation of “uncreated and imperishable . . . whole and of single kind and unshaken and perfect.”")]), _c('a', {
    attrs: {
      "id": "fn1"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here, among the early Greek philosophers, we observe that a question about knowledge is immediately transformed into a question about metaphysics."), _c('a', {
    attrs: {
      "id": "fn2"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2"
    }
  }, [_vm._v("2")])]), _vm._v(" Heraclitus (fl. 500 BC), Parmenides’s contemporary, argued that unchanged and motionless being is not the object of true knowledge; instead "), _c('i', [_vm._v("change")]), _vm._v(" is eternal. For Heraclitus, the ultimate nature of reality is not static and harmonious in the way Parmenides thought. The underlying harmony is to be found in corresponding states that are in eternal opposition. This leads him to conclude, “It is necessary to know that war is common and right is strife, and that all things happen by strife and necessity.”"), _c('a', {
    attrs: {
      "id": "fn3"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3"
    }
  }, [_vm._v("3")])]), _vm._v(" This river-like constant change shows people their true place in the world: “War is the father of all and king of all, and some he shows as gods, others as men, some he makes slaves, others free.”"), _c('a', {
    attrs: {
      "id": "fn4"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4"
    }
  }, [_vm._v("4")])]), _vm._v(" War and strife are eternal; their cessation would indicate the end of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here we have two basic stances that were to become the two opposite poles of stability and change, being and nothingness, toward which all metaphysical solutions gravitate in the history of Western philosophy. These disputes, which go back to the first serious attempts to philosophize, illustrate the complexity of disagreement. If our disagreements were only about "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("perception, things might not be that serious.")]), _c('a', {
    attrs: {
      "id": "fn5"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5"
    }
  }, [_vm._v("5")])]), _vm._v(" However, we are immediately faced with metaphysical questions, which are consequently linked to questions of value. In ancient philosophy the different topics of philosophy were so intermingled that it was not possible to distinguish between epistemology, metaphysics, philosophy of mind, and political philosophy, as happens in modern philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Plato")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Plato’s epistemology is tied directly to his metaphysical views. In the "), _c('i', [_vm._v("Republic")]), _vm._v(", for example, Plato argues that perceptible things cannot be the object of proper knowledge since perceptible things can present themselves in ways that contradict each other. That is why convictions regarding perceptible objects are just opinions ("), _c('i', [_vm._v("doxa")]), _vm._v("). Knowledge ("), _c('i', [_vm._v("epistēmē")]), _vm._v(") is possible only in relation to Ideas. Sometimes it seems that Plato restricts knowledge only to the knowing of the One ("), _c('i', [_vm._v("hen")]), _vm._v(") and immediately related ideas, with the result that one actually “knows” very few things. Consequently, if knowledge proper is only about "), _c('i', [_vm._v("hen")]), _vm._v(", epistemology regarding ordinary things loses much of its value as a reasonable pursuit. We should not let the shadows on the wall drag us into senseless disputes because our opinions about them are necessarily deficient."), _c('a', {
    attrs: {
      "id": "fn6"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Nevertheless, even if Plato is not interested in the justification of beliefs in a modern sense, he believes that things such as goodness and justice are worth serious examination. In Plato’s "), _c('i', [_vm._v("Phaedrus")]), _vm._v(", Socrates points out that we tend to agree on simple things but get easily confused when faced with issues like justice and goodness, especially if we fall under the influence of a master rhetorician."), _c('a', {
    attrs: {
      "id": "fn7"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "Hang1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('i', [_vm._v("Socrates")]), _vm._v(": Every one is aware that about some things we are agreed, whereas about other things we differ.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "Hang"
  }, [_c('i', [_vm._v("Phaedrus")]), _vm._v(": I think that I understand you; but will you explain yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_c('i', [_vm._v("Socrates")]), _vm._v(": When any one speaks of iron and silver, is not the same thing present in the minds of all?")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_c('i', [_vm._v("Phaedrus")]), _vm._v(": Certainly.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_c('i', [_vm._v("Socrates")]), _vm._v(": But when any one speaks of justice and goodness we part company and are at odds with one another and with ourselves?")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_c('i', [_vm._v("Phaedrus")]), _vm._v(": Precisely.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_c('i', [_vm._v("Socrates")]), _vm._v(": Then in some things we agree, but not in others?")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_c('i', [_vm._v("Phaedrus")]), _vm._v(": That is true.")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_c('i', [_vm._v("Socrates")]), _vm._v(": In which are we more likely to be deceived, and in which has rhetoric the greater power?")])]), _c('p', {
    staticClass: "Hang"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('i', [_vm._v("Phaedrus")]), _vm._v(": Clearly, in the uncertain class.")]), _c('a', {
    attrs: {
      "id": "fn8"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The above dialogue underlines the need for criteria and standards against which values are evaluated. The criticism of rhetoric arises from the debaters’ analysis of Lysia’s speech on love. Socrates and Phaedrus criticize Lysia for not defining the concepts he is using. This way Lysia “begins at the end”: from the conclusions without properly introducing his arguments, necessary concepts, and their definitions. Consequently, masses are led astray by rhetoricians who make complicated things look simple. Against this view, Socrates argues that dialectic (philosophy) is greater than rhetoric because it leads people to understand the things as they are."), _c('a', {
    attrs: {
      "id": "fn9"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Nicholas White notes that the peculiarity of Plato’s “metaphysical epistemology” is found in the cases of puzzlement regarding particular goods. There is no talk about different contexts or ways of knowing (because the context is always less than ideal for humans). Plato simply goes on to explain what this particular good consists of "), _c('i', [_vm._v("in reality")]), _vm._v(".")]), _c('a', {
    attrs: {
      "id": "fn10"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10"
    }
  }, [_vm._v("10")])]), _vm._v(" In the "), _c('i', [_vm._v("Republic")]), _vm._v(", Plato’s suggested solution to value disagreements is the meditation of Ideas. But is our knowledge of Ideas more secure?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Plato’s imagined republic reflects the human soul’s ideal condition: the rational part of the soul rules over the irrational part. In like manner, society’s lower classes behave rationally when they submit themselves to the upper classes, and the upper classes are rational when they rule wisely over the lower classes."), _c('a', {
    attrs: {
      "id": "fn11"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11"
    }
  }, [_vm._v("11")])]), _vm._v(" The utopian state is needed to educate people in the right way; namely, if people are subjected to a substandard moral environment in their youth, it is almost impossible to correct them later. As an example of perfection, Plato envisions an ideal judge who has not been familiarized with crimes in his youth, but who “should have learned to know evil, not from his own soul, but from late and long observation of the nature of evil in others.”"), _c('a', {
    attrs: {
      "id": "fn12"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Plato has no rosy view of humanity."), _c('a', {
    attrs: {
      "id": "fn13"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13"
    }
  }, [_vm._v("13")])]), _vm._v(" Truth is easily corrupted, and human nature is prone to go astray if not properly tutored. This leads him to create a utopian (and totalitarian) state, which enables humans to achieve harmony and happiness ("), _c('i', [_vm._v("eudaimonia")]), _vm._v("). Plato argues that conflicts typically arise in situations when there is some question of ownership. As a result, conflicts can be avoided by removing standard family structures and private property. This radical reorganization of social life should lead to equitable treatment. However, the sense of ownership extends to one’s own body and makes the complete uprooting of the notion of the private ("), _c('i', [_vm._v("idion")]), _vm._v(") impossible. Here we face the crucial moment in Plato’s theory, summarized by Martha Nussbaum: “For the body is not only the biggest obstacle to stable life and to "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("true evaluation; it is also the most dangerous source of conflict, and therefore the biggest obstacle to impartial and harmonious civic justice.”")]), _c('a', {
    attrs: {
      "id": "fn14"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not only the commoners who suffer from their bodily restrictions; philosophers are subject to it as well. In Plato’s utopian state, philosophers rule the other classes, who willingly submit themselves to philosophers’ tutelage. For this reason, philosophers cannot have any private property either; honor is their only salary. However, other classes do not easily yield to philosophers’ rule. Even if philosophical knowledge is available for all, it is easily lost, and it cannot be promulgated to the society as a whole if the correct system, namely, a utopian state, is not in place.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Plato senses that even philosophers can become corrupt, which consequently makes it harder to use the Ideas as the starting point from which to start intellectual enquiry."), _c('a', {
    attrs: {
      "id": "fn15"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15"
    }
  }, [_vm._v("15")])]), _vm._v(" This underscores the fragility of his utopian state, and eventually leads him to conclude that such a state will never come into being. Instead, we should strive for the "), _c('i', [_vm._v("Republic")]), _vm._v("’s ideals without the state’s support. Even in the less-than-ideal state, it is the philosophers’ task to enter the cave they have left behind and educate the cave dwellers."), _c('a', {
    attrs: {
      "id": "fn16"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Plato offers several enduring pieces of advice on managing disagreement in our time. The rhetoricians are still among us and continue to lead people in multiple directions. However, the means of bringing the desired state about are not well suited for contemporary democracies. For Plato, politics is not about coming together from different backgrounds and trying to find a common way; the common people have nothing worthwhile to say. Knowledge is restricted to the philosophical elite. Plato’s state is an intellectual aristocracy, which, sadly, is not able to secure its own internal consensus, as the later history of philosophy demonstrates, and which Plato himself also anticipates.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Aristotle")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Aristotle follows the basic division of the parts of the soul that was assumed in Plato’s Academy. According to Aristotle, the human soul consists of three parts: vegetative, appetitive or animal, and rational. The vegetative soul joins us together with the world of nature, and it does not actually have an effect on our actions. The animal soul is responsible for those actions that we have in common with living beings, such as sensations, desires, and emotions. The properly human part is the rational soul, and it is divided into theoretical and calculative parts. The theoretical part deals with scientific reasoning, while the calculative part determines which actions we should perform.")]), _c('a', {
    attrs: {
      "id": "fn17"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An action (and the person who performs it) can be regarded as good when the rational and appetitive parts work together harmoniously so that the action resonates with the particular good that is the action’s goal."), _c('a', {
    attrs: {
      "id": "fn18"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18"
    }
  }, [_vm._v("18")])]), _vm._v(" If the calculative part does not rule over the appetitive part, the person in question behaves like an animal driven by its involuntary desires.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("How, then, does the person engage with the world in a rational way? Aristotle’s philosophy of mind is simple and even optimistic: the world appears to the observer simply as it is. The standard model of Aristotelian knowledge acquisition operates with the following sequence: sense perception, apprehension of single essences, and discursive reasoning. The central notion in any act of perception is the intelligible species ("), _c('i', [_vm._v("species intelligibilis")]), _vm._v("), or the “secondary form.” The classic passage in Aristotle’s "), _c('i', [_vm._v("De anima")]), _vm._v(" reads as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("In general, with regard to all sense-perception, we must take it that the sense is that which can receive perceptible forms without their matter, as wax receives the imprint of the ring without the iron or gold, and it takes the imprint which is of gold or bronze, but not "), _c('i', [_vm._v("qua")]), _vm._v(" gold or bronze."), _c('a', {
    attrs: {
      "id": "fn19"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This species ("), _c('i', [_vm._v("eidos")]), _vm._v(", "), _c('i', [_vm._v("forma")]), _vm._v("), or form,"), _c('a', {
    attrs: {
      "id": "fn20"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20"
    }
  }, [_vm._v("20")])]), _vm._v(" was taken to be something that is present in the soul of the observer; that is to say, this species somehow shapes the intellect so that they share the same form with the object."), _c('a', {
    attrs: {
      "id": "fn21"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21"
    }
  }, [_vm._v("21")])]), _vm._v(" This makes "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("knowledge acquisition sound easy. Aristotle’s view is more optimistic than Plato’s, as he thinks that humans are generally well equipped to perceive reality as it is. The world’s weight on our shoulders is so overwhelming that it necessarily pushes us in the right direction. Perception, however, is not without obstacles, and this apparent simplicity should not lead us to think that knowledge acquisition is free from errors.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("In addition to appearances ("), _c('i', [_vm._v("phainomena")]), _vm._v("), our knowledge is based on “credible, received opinions” ("), _c('i', [_vm._v("endoxa")]), _vm._v("). "), _c('i', [_vm._v("Endoxa")]), _vm._v(" is a central Aristotelian epistemological concept that has recently received scholarly attention, and it has been suggested that instead of being an uncomplicated empiricist, Aristotle might be part constructivist.")]), _c('a', {
    attrs: {
      "id": "fn22"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22"
    }
  }, [_vm._v("22")])]), _vm._v(" Aristotle goes to great lengths to argue that "), _c('i', [_vm._v("endoxa")]), _vm._v(" are to be taken seriously in knowledge acquisition, as appearances can be deceiving, which may lead to puzzlement ("), _c('i', [_vm._v("aporia")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("As in other cases, we must set out the appearances ["), _c('i', [_vm._v("phainomena")]), _vm._v("] and run through all the puzzles regarding them. In this way we must prove the credible opinions ["), _c('i', [_vm._v("endoxa")]), _vm._v("] about these sorts of experiences—ideally, all the credible opinions, but if not all, then most of them, those which are the most important. For if the objections are answered and the credible opinions remain, we shall have an adequate proof."), _c('a', {
    attrs: {
      "id": "fn23"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In other words, Aristotle aims at collecting together all respectable opinions about the disputed matter and representing them in a way that does justice to diverse opinions. This demonstrates how every perspective has intrinsic value in the ongoing process that aims toward greater truth."), _c('a', {
    attrs: {
      "id": "fn24"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24"
    }
  }, [_vm._v("24")])]), _vm._v(" Nicholas ­Denyer sums up Aristotle’s method for overcoming disagreements aptly:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("We thus assemble into a systematic and harmonious synthesis as much as possible of the opinions and impressions with which we began. This synthesis will incorporate all the insights that anyone has ever had on the subject, and yet be free of all their errors. The idea is that truth will survive the dialectical process that results in this synthesis, whereas falsehood cannot. And because all parties will be able to recognise in this synthesis a statement of the truth that they were getting at, and an "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("explanation of any falsehoods into which they might have lapsed, this synthesis should command universal assent. It will have something of the authority over us of a treaty negotiated by the good offices of a master diplomat: everybody will be able to recognise that the synthesis has done justice to everybody’s legitimate concerns. And finally, once we have reached such a synthesis, our investigations need go no further. The synthesis will provide an account of our subject matter that is correct, complete, and justified.")]), _c('a', {
    attrs: {
      "id": "fn25"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Ekaterina Haskins concludes that Aristotle makes the “human race as a whole the measure of how things are absolutely.”"), _c('a', {
    attrs: {
      "id": "fn26"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26"
    }
  }, [_vm._v("26")])]), _vm._v(" Here Aristotle’s philosophy of mind comes again to the fore; if the individual soul mirrors the world, how much greater is the power of all human souls working together? Yet he still holds an appreciation for the value of the “wise” ("), _c('i', [_vm._v("phro­nimoi")]), _vm._v(") in contrast to ordinary people."), _c('a', {
    attrs: {
      "id": "fn27"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27"
    }
  }, [_vm._v("27")])]), _vm._v(" This effectively sets Aristotle against the strongest constructivist readings. In "), _c('i', [_vm._v("Topics")]), _vm._v(", he defines "), _c('i', [_vm._v("endoxa")]), _vm._v(" as “the things believed by everyone or by most people or by the wise (and among the wise by all or by most or by those most known and commonly recognized).”"), _c('a', {
    attrs: {
      "id": "fn28"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28"
    }
  }, [_vm._v("28")])]), _vm._v(" Disagreements are thus resolvable, given enough time, through common reasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Aristotle’s teleological reading of nature and his political theory, which stresses humanity’s natural inclination to form stable communities, is the scaffolding that supports his optimistic view. While Plato seeks maximal unity within the state based on the destruction of ownership and the rule of philosopher-kings, Aristotle thinks that seeking this kind of unity is against the nature of both polis and humanity. Societies are inherently plural since their citizens are plural. We must learn to live with that fact unless we want to obliterate politics altogether."), _c('a', {
    attrs: {
      "id": "fn29"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Aristotle also criticizes Plato’s suggestion that conflicts are a result of structural elements that make people do bad or unwise things. Against this view, Aristotle points out that it is not necessarily structural inequality that drives people to become highwaymen but their inordinate desires that seek pleasure.")]), _c('a', {
    attrs: {
      "id": "fn30"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30"
    }
  }, [_vm._v("30")])]), _vm._v(" Thus Aristotle more strongly emphasizes individual duties toward other citizens than Plato does in the "), _c('i', [_vm._v("Republic")]), _vm._v(": it is up to each one to strive to become a moral person, regardless of external circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s02"
    }
  }, [_vm._v("1.2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Varieties of Goodness: Augustine and Aquinas")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Augustine")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("For Augustine, the question of disagreement arose naturally at several junctures in his intellectual life. In his convoluted journey from Manichaeanism to Catholic Christianity, he experienced various ruptures with the traditions he was engaged in. Most notably, on several occasions Augustine ponders the fact that philosophers continue to disagree with each other while they claim that the use of reason will lead them to truth."), _c('a', {
    attrs: {
      "id": "fn31"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31"
    }
  }, [_vm._v("31")])]), _vm._v(" In the early phase of his career, he tackled the skeptical challenge in his "), _c('i', [_vm._v("Contra Academicos")]), _vm._v(", where he steers away from skepticism by demonstrating that it leads to performative contradictions: in order to doubt, you must know."), _c('a', {
    attrs: {
      "id": "fn32"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32"
    }
  }, [_vm._v("32")])]), _vm._v(" The same problem took "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("form within the church in bitter controversies with the Donatists: Why did these apparently sincere people refuse to follow what Augustine perceived to be the legitimate form of church government?")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Paul J. Griffiths sees two reasons why Augustine thinks our reasoning often leads us astray.")]), _c('a', {
    attrs: {
      "id": "fn33"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33"
    }
  }, [_vm._v("33")])]), _vm._v(" First, we might not be adequately catechized; that is to say, we do not have enough knowledge about the matter, which makes us unable to properly understand the issue at hand. Second, our depraved will prevents us from even wanting to know the truth. Let us take a closer look at each of these points.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In "), _c('i', [_vm._v("Enchiridion")]), _vm._v(", Augustine acknowledges that is it simply impossible for us to avoid ignorance, which is one of the main sources of error."), _c('a', {
    attrs: {
      "id": "fn34"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34"
    }
  }, [_vm._v("34")])]), _vm._v(" In "), _c('i', [_vm._v("De catechizandis rudibus")]), _vm._v(" he approaches the problem from the viewpoint of semantics. Why do we feel bored when we teach about things that should be wonderful and set our hearts on fire? Surely, if the teacher is not passionate, the listeners will find the material uninteresting. Augustine offers the following explanation. The words used to teach are already two steps removed from the subject being taught. The divine truth has been illumined and realized in the teacher’s mind (step one), and it is being communicated to the hearers through words (step two). This distance from the thing being taught understandably results in a lack of interest."), _c('a', {
    attrs: {
      "id": "fn35"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35"
    }
  }, [_vm._v("35")])]), _vm._v(" As a result, in Augustine’s theological epistemology, words and proofs become largely irrelevant. Words are pointers toward something that they do not essentially contain. Consequently, merely hearing the words is not going to help anyone if one does not already know what the words signify. The one reading Scripture needs to be illumined by God "), _c('i', [_vm._v("before")]), _vm._v(" reading, otherwise one's understanding is destined to be erroneous."), _c('a', {
    attrs: {
      "id": "fn36"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In "), _c('i', [_vm._v("De doctrina Christiana")]), _vm._v(", Augustine explains that some signs are natural. In the case of sensing smoke, for example, we take it to mean there’s fire "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("somewhere. However, some signs are given, rather than natural, and therefore ambiguous. This pertains to the names of things that conscious beings use to communicate with each other.")]), _c('a', {
    attrs: {
      "id": "fn37"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37"
    }
  }, [_vm._v("37")])]), _vm._v(" Interestingly, Augustine expands the ambiguous nature of sign-giving to God’s revelation as well, claiming that “even the divinely given signs contained in the holy scriptures have been communicated to us by the human beings who wrote them.”"), _c('a', {
    attrs: {
      "id": "fn38"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38"
    }
  }, [_vm._v("38")])]), _vm._v(" Thus signs are not the same in every context. Augustine refers to the tower of Babel as a sign of artificial unity, which was torn down in order to cure humans of their pride: “Wicked men justly received incompatible languages to match their incompatible minds.”"), _c('a', {
    attrs: {
      "id": "fn39"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39"
    }
  }, [_vm._v("39")])]), _vm._v(" Consequently, even the reading of the Scriptures inevitably leads to disagreement. But Augustine sees a divine plan behind this: Exertion and toil in interpretation is good for humans as it cures their souls of harmful attitudes.")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Casual readers are misled by problems and ambiguities of many kinds, mistaking one thing for another. In some passages they find no meaning at all that they can grasp at, even falsely, so thick is the fog created by some obscure phrases. I have no doubt that this is all divinely predetermined, so that pride may be subdued by hard work and intellects which tend to despise things that are easily discovered may be rescued from boredom and reinvigorated."), _c('a', {
    attrs: {
      "id": "fn40"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("But sometimes the increase of knowledge as such is not enough, as is evident in the case of mutually disagreeing philosophers. At this point of history, Augustine is already wrestling with substantial philosophical traditions. The novelty that he introduces to the ancient theory of knowledge is the role of love and sin in decision-making. According to some later Stoics, our scattered actions and convictions result from the weakness of our will ("), _c('i', [_vm._v("akrasia")]), _vm._v("), but for Augustine this is not enough to explain the widespread disagreements among equally intelligent thinkers. The analysis of will, as provided by the ancients, does not penetrate deep enough. It is not only what we want but also what we love or hate that directs our course of action. "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Our actions are teleological, formed by our loves, which aim for some ultimate end.")]), _c('a', {
    attrs: {
      "id": "fn41"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn41"
    }
  }, [_vm._v("41")])]), _vm._v(" Consequently societies are formed by shared love among their members."), _c('a', {
    attrs: {
      "id": "fn42"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn42"
    }
  }, [_vm._v("42")])]), _vm._v(" This emphasis on will and love gives Augustine’s social theory a special twist: perverted love creates disagreement, and purified love, unity. In "), _c('i', [_vm._v("Confessions")]), _vm._v(", Augustine writes:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("For just as in violent acts, if the emotion of the soul from whence the violent impulse springs is depraved and asserts itself insolently and mutinously—and just as in the acts of passion, if the affection of the soul which gives rise to carnal desires is unrestrained—so also, in the same way, errors and false opinions contaminate life if the rational soul itself is depraved. Thus it was then with me, for I was ignorant that my soul had to be enlightened by another light, if it was to be partaker of the truth, since it is not itself the essence of truth."), _c('a', {
    attrs: {
      "id": "fn43"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn43"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In this way, Augustine introduces explicitly religious considerations. If we were to follow the advice of philosophers, we should be able to bring about a state of harmony by using our reason alone. But observing their arguments and conclusions only leads to mutually excluding positions. This disagreement Augustine takes to be a result of inner convictions that connect individuals with higher ends."), _c('a', {
    attrs: {
      "id": "fn44"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn44"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Augustine thus is aligned closer with Plato than Aristotle: an optimistic right method and an optimistic view of human knowledge-acquisition skills are not going to resolve all disagreement. However, he does not follow Plato’s utopian ideals, and is rather pessimistic regarding the possibility of a long-lasting state of harmony because of the perverted order of love, which cannot be fully mended in this life."), _c('a', {
    attrs: {
      "id": "fn45"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn45"
    }
  }, [_vm._v("45")])]), _vm._v(" This does not mean, however, that "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("attempts at reconciliation are futile. With proper instruction things can be changed. In "), _c('i', [_vm._v("De Doctrina Christiana")]), _vm._v(", for example, Augustine offers an amusing anecdote.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "EX"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("I was once appealing to the people in Caesarea of Mauretania to abandon their civil strife, or rather that conflict worse than civil strife which they called "), _c('i', [_vm._v("caterva")]), _vm._v(", in which regularly at a particular time of the year not merely citizens, but even close relatives, brothers, and even parents and sons used to split into opposing gangs and fight with stones continuously for several days, slaughtering whomever they could. I spoke, to the best of my ability, in the grand style, in order to eradicate and eliminate such a cruel and chronic evil from their hearts and their habits by my words. I did not think that I had achieved anything when I heard them applaud, but only when I saw them in tears. Their applause showed that they were receiving instruction and experiencing delight; their tears that they were moved. It was when I saw this—and before they showed it in their actions—that I believed that this brutal practice, inherited from their fathers and grandfathers and remoter ancestors, which so fatally obsessed, or rather possessed, their hearts, had been overcome. Quickly finishing my speech, I occupied their hearts and mouths in giving thanks to God.")]), _c('a', {
    attrs: {
      "id": "fn46"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("These momentary glimpses of peace are set in context in "), _c('i', [_vm._v("De civitate Dei")]), _vm._v(", where Augustine draws a picture of two cities, earthly and heavenly. Almost in Heraclitean tones, he depicts how these cities have always been, and always will be, in enmity with each other."), _c('a', {
    attrs: {
      "id": "fn47"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn47"
    }
  }, [_vm._v("47")])]), _vm._v(" The earthly city is characterized by violence and strife: “The society of mortals spread abroad through the earth everywhere, and in the most diverse places, although bound together by a certain fellowship of our common nature, is yet for the most part divided against itself, and the strongest oppress the others, because all "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("follow after their own interests and lusts.”")]), _c('a', {
    attrs: {
      "id": "fn48"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn48"
    }
  }, [_vm._v("48")])]), _vm._v(" In the earthly city, everyone seeks their own happiness, which inevitably leads to conflict. The earthly city can reach the state of peace only through war. This peace is good in itself, as it enables the enjoyment of earthly goods, yet it is ontologically distinct from the heavenly peace that consists of the unity of souls existing in participation with God and experiencing total transparency to each other. In this heavenly state there can be no disagreement, because everyone wills the same thing. Inversely, earthly peace is not based on the unity of will and on a shared object of love, but in the fear of punishment. Nevertheless, this peace is worth pursuing even if it is not perfect."), _c('a', {
    attrs: {
      "id": "fn49"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn49"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Earthly peace is always contingent and fragile. Members of the heavenly city can share this peace as long as they do not have to compromise their faith and loyalty to the heavenly city. In this life they share the eternal peace only by faith. In the next life, this peace will be perfected as our wills will be conjoined in harmony with the divine will, which makes conflicts cease once and for all."), _c('a', {
    attrs: {
      "id": "fn50"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Thomas Aquinas")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In order to examine what Aquinas has to say about disagreement, we need to first explain how he perceives human cognitive processes. Aquinas’s theory of judgment and action is deeply nuanced, and it changes throughout the "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('i', [_vm._v("Summa theologiae")]), _vm._v("’s volumes. I do not hope to offer a complete overview of this issue, but instead try to concentrate on the essentials.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Aquinas adopts a broadly Aristotelian theory of cognition: knowledge is based on the forms of objects present in one’s soul. More detailed exposition of this theory of action reveals the complexities of knowledge acquisition. In Aquinas’s philosophy of mind, action is performed as follows: First, a sense experience evokes a desire. Desires have a cognitive component that makes them processable by the will and, consequently, by reason. The will, having experienced a desire, asks reason for guidance: is this apparent good a genuine good? Then reason, based on its acquired notion of goodness and happiness, either affirms or denies the will’s proposal. The will is ultimately dependent on reason and its evaluations of what is good and promotes happiness. If reason does not have the correct understanding of the good, it leads us astray.")]), _c('a', {
    attrs: {
      "id": "fn51"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn51"
    }
  }, [_vm._v("51")])]), _vm._v(" In this way, intellect and will work together and are interrelated."), _c('a', {
    attrs: {
      "id": "fn52"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn52"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to Aquinas, reality, as God’s creation, is a harmonious unity. Like Aristotle, Aquinas believes the world is presented to us as it is, and the problem of radical skepticism does not appear to him as a real problem that needs addressing. Additionally, there is no conflict between faith and reason. Even if he recognizes the real possibility of superficial conflict, for Aquinas there can be no real, irresolvable value-judgment conflicts."), _c('a', {
    attrs: {
      "id": "fn53"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Value judgments are based on the knowledge of first principles, which are abstract, action-guiding propositions, such as “good must be done and evil avoided.”"), _c('a', {
    attrs: {
      "id": "fn54"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn54"
    }
  }, [_vm._v("54")])]), _vm._v(" First principles are both immediate and indemonstrable. By this Aquinas means that when one encounters first principles, one immediately understands that they are necessarily and universally true; their falsehood is incomprehensible. Even if first principles are in principle knowable to all, it is not necessary that everyone in fact is able to know them. For instance, "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("it is possible to misunderstand the nature of subject and predicate in a given proposition. Disagreeing with first principles is possible if one does not understand what they mean. Additionally, due to the complexity of some issues, it is occasionally difficult to understand the proposition. Some degree of uncertainty remains as a result.")]), _c('a', {
    attrs: {
      "id": "fn55"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn55"
    }
  }, [_vm._v("55")])]), _vm._v(" In other words, some disagreements are merely due to our limited knowledge and can be resolved through better comprehension of the matter at hand."), _c('a', {
    attrs: {
      "id": "fn56"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn56"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("According to Aquinas, the sin’s presence in the soul does not alter the basic functions of the intellect; it continues to apprehend reality in a reliable manner. But while sin does not affect reason’s basic cognitive function, it can turn reason away from the highest good, and this may lead reason to perform various errors, listed below, which are also potential causes of disagreement.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("First, reason may not comprehend how particular knowledge or action can be accidentally linked to evil. This can be the case when we seek knowledge to learn something in order to sin, or we are unable to see the true nature of our actions; for example, when one desires something and is unable to weigh the proper consequences of the actions that satisfy the desire. Second, our appetite for knowledge can be inordinate, which can lead, for example, to acquiring knowledge through illicit means. Third, we may want to know things that exceed our capacity, and this can lead us to err. Most serious, however, is knowledge acquisition that is unable to relate itself to the highest good, that is, God.")]), _c('a', {
    attrs: {
      "id": "fn57"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn57"
    }
  }, [_vm._v("57")])]), _vm._v(" Aquinas states that the corruption of "), _c('i', [_vm._v("theoria")]), _vm._v(" is possible “when a man desires to know the truth about creatures, without referring his knowledge to its due end, namely, the knowledge of God. Hence, Augustine says ("), _c('i', [_vm._v("De Vera Relig")]), _vm._v(". 29) that ‘in studying creatures, we must not be moved by empty and perishable curiosity; but we should ever mount toward immortal and abiding things.’”"), _c('a', {
    attrs: {
      "id": "fn58"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn58"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But why is disregarding God, or the ultimate order of things, in knowledge acquisition so serious? Aquinas links his answer to the hierarchy of goods. If God is not loved above everything else, and all other good things in relation to the supreme good, the goodness of these created things is lost because our desires do not conform to reality. In other words, we perceive "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("the reality in a truncated or false way. Depending on the case, this may lead to harmless miscalculations or, in the worst case, harm to one’s soul.")]), _c('a', {
    attrs: {
      "id": "fn59"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn59"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Alasdair MacIntyre discusses this problem in relation to the nature of philosophical enquiry from a broadly Thomistic perspective."), _c('a', {
    attrs: {
      "id": "fn60"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn60"
    }
  }, [_vm._v("60")])]), _vm._v(" Philosophy is in constant danger of committing two opposite vices. On the one hand, it is possible to proceed in one’s enquiry in a piecemeal fashion so that the examined topics remain disconnected from other bodies of knowledge. This MacIntyre calls the “analytical vice.” On the other hand, we are in danger of committing the “idealist vice” when we gloss over the difficulties in our grand system that could possibly challenge it. Both these vices are problematic because they inevitably hinder knowledge acquisition and make it more difficult to ask proper philosophical questions about the nature of the human good. For Aquinas, these questions cannot be answered properly without the inclusion of God within the hierarchy of goods.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Based on the above, we can see how disagreement can be both a result of our limited cognition (when we are not culpable in a real sense) and our distorted will that follows the wrong order of love. For Aquinas, disagreement is realized when we lack adequate knowledge or when our love directs either our reason or our will toward an end that is not the highest good."), _c('a', {
    attrs: {
      "id": "fn61"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn61"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But let us return to first principles. The first, nonspeculative principles function as the primary precepts of natural law."), _c('a', {
    attrs: {
      "id": "fn62"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn62"
    }
  }, [_vm._v("62")])]), _vm._v(" The primary precepts are the same for everyone: unchanging, self-evident, and, in principle, known to all. The knowledge of first principles can never be undone from the human heart. However, as already noted, these precepts include only very basic principles, such as “good is to be done, and evil avoided.” But if knowledge of the first principles is so pervasive, why do we quarrel about beliefs and morals? "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Things get murky when first principles are applied to particular situations. Although primary principles are universal, their application always takes place in a cultural setting, which gives them a certain shape. Furthermore, we may lack adequate experience and knowledge, or practical wisdom ("), _c('i', [_vm._v("phronēsis")]), _vm._v("), which could guide our judgment.")]), _c('a', {
    attrs: {
      "id": "fn63"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn63"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The notion was explained earlier that happiness gives direction to reason and will. Aquinas readily acknowledges that it is possible to define good and happiness in manifold ways. In the "), _c('i', [_vm._v("Summa theologiae")]), _vm._v(", he lists as possible candidates things such as wealth, honor, fame, glory, power, bodily or spiritual goods, and pleasure."), _c('a', {
    attrs: {
      "id": "fn64"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn64"
    }
  }, [_vm._v("64")])]), _vm._v(" If any of these is taken as the goal of one’s actions, a particular way of life follows, where actions, moral deliberation, and preferences resonate with the respective ultimate goal. It is easy to see how this gives rise to conflicts."), _c('a', {
    attrs: {
      "id": "fn65"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn65"
    }
  }, [_vm._v("65")])]), _vm._v(" In his defense of Aquinas’s natural law theory, MacIntyre offers several ways to adjudicate between various goods and reach for agreement, which includes spelling out in more detail the central beliefs about human nature and ultimate value and so on."), _c('a', {
    attrs: {
      "id": "fn66"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn66"
    }
  }, [_vm._v("66")])]), _vm._v(" (These suggestions will be discussed later in this book.) However, he concedes that even with Aquinas’s lights, we should not expect “reasonable” discussion to lead inevitably to agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s03"
    }
  }, [_vm._v("1.3."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Method Men: Bacon and Descartes")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The chaotic state of late medieval philosophy and the Protestant Reformation disrupted the fragile and superficial consensus of the early sixteenth century, and a new search for sure foundations was launched. From Francis Bacon’s "), _c('i', [_vm._v("New Organon")]), _vm._v(" through René Descartes’s "), _c('i', [_vm._v("Meditations")]), _vm._v(" to Locke’s praise of “reasonability,” the hearts of the philosophers were filled with the hope that we would soon possess the necessary tools for determining the foundations of the universe.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the seventeenth century, Western civilization had to face the reality of disagreement in multiple spheres of life. The New World had been “discovered” "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("one hundred years earlier, and the knowledge of other civilizations and religions had become an accepted fact. Martin Luther had opened the spiritual Pandora’s box, and new ways of practicing faith were introduced everywhere in Europe. The Scientific Revolution was already underway. Change was in the air, but how to ensure that this change was for the better?")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("Francis Bacon")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Shortly after the Thirty Years’ War began, Francis Bacon (1561–1626) published a programmatic treatise, "), _c('i', [_vm._v("The New Organon")]), _vm._v(" (1620), which laid out the plan for the renewal of science and philosophy. Looking back at the history of science, Bacon sees only philosophers waging war against each other. Bacon was distrustful of “pure” reason; he sought a more trustworthy method. After the fall, humankind’s epistemic abilities were marred (along with a host of other deleterious effects within creation). What was needed was not a haughty reliance on mere reason, but a method producing knowledge that could be taken up as a communal enterprise successively transmitted from one generation to another. In "), _c('i', [_vm._v("The Great Instauration")]), _vm._v(", Bacon locates the problem in the human mind’s limitations, which will continue to lead us into errors if something radical is not done.")]), _c('a', {
    attrs: {
      "id": "fn67"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn67"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Now that the errors which have hitherto prevailed, and which will prevail for ever, should (if the mind be left to go its own way) either by the natural force of the understanding or by help of the aids and instruments of logic, one by one, correct themselves, was a thing not to be hoped for, because the primary notions of things which the mind readily and passively imbibes, stores up, and accumulates (and it is from them that all the rest flow) are false, confused, and overhastily abstracted from the facts; nor are the secondary and subsequent notions less arbitrary and inconstant; whence it follows that the entire fabric of human reason which we employ in the inquisition of nature is badly put together and built up, and like some magnificent structure without any foundation."), _c('a', {
    attrs: {
      "id": "fn68"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn68"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Bacon takes the human soul to be a thoroughly corrupted instrument, fundamentally damaged by Adam’s fall from what was humanity’s original righteousness. The fall had a profound effect on human cognitive powers: unaided, human senses are not trustworthy. Our limited condition leads us to misperceive reality; even if we perceive something correctly, we do not necessarily understand it properly ("), _c('i', [_vm._v("Great Instauration")]), _vm._v(", 79).")]), _c('a', {
    attrs: {
      "id": "fn69"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn69"
    }
  }, [_vm._v("69")])]), _vm._v(" Nor is the intellect free from sin. This is proved by the incompetence of ancient philosophers and schoolmen. Bacon laments that “formerly there existed among philosophers such great disagreement, and such diversities in the schools themselves, a fact which sufficiently shows that the road from the senses to the understanding was not skillfully laid out, when the same groundwork of philosophy (the nature of things to wit) was torn and split up into such vague and multifarious errors” ("), _c('i', [_vm._v("New Organon")]), _vm._v(", 114). The rule of philosophy over science leads to a sad state, in which “what is now done in the matter of science there is only a whirling round about, and perpetual agitation, ending where it began” ("), _c('i', [_vm._v("Great Instauration")]), _vm._v(", 66–67). Bacon uses colorful, sexual imagery to prove the infertility of philosophy, as he claims that the knowledge of Greeks “is but like the boyhood of knowledge, and has the characteristic property of boys: it can talk, but it cannot generate, for it is fruitful of controversies but barren of works” ("), _c('i', [_vm._v("Great Instauration")]), _vm._v(", 69). He also likens philosophy to Scylla, who had the face of a virgin but in the place of a womb she had heads of horrible monsters. Respectively, “when they [philosophers] should produce fruit and works, then arise contentions and barking disputations, which are the end of the matter and all the issue they can yield” ("), _c('i', [_vm._v("Great Instauration")]), _vm._v(", 69).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Bacon’s most well-known image is of four idols that lead people astray: the idols of the tribe, idols of the cave, idols of the marketplace, and idols of the theater ("), _c('i', [_vm._v("New Organon")]), _vm._v(", 95–108). The idols of the tribe are habitual inclinations to make false inferences. The human mind is “like a false mirror, which, receiving rays irregularly, distorts and discolors the nature of things by mingling its own nature with it” ("), _c('i', [_vm._v("New Organon")]), _vm._v(", 96). Such things as imagination, emotions, irrational will, and lack of conscientiousness impede our reasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The idols of the cave are limitations that result from one’s personal perspective and location in the world. Each of us has our own background, "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("experiences, and education, all of which narrow and fix our gaze on certain things. The idols of the marketplace are weaknesses of human language. By this Bacon means that we can use words that have no real meaning, or more precisely, we cannot fix the meaning of the words through empirical means. These “lead men away into numberless empty controversies and idle fancies” ("), _c('i', [_vm._v("New Organon")]), _vm._v(", 96). These three idols are our natural companions, and it is hard to resist their power over us. However, we can fight the fourth idol, the idols of theater, which refers to false authorities. First and foremost, these are philosophical systems, which in one way or another shackle our thoughts.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("The suggested cure for this malaise is the introduction of "), _c('i', [_vm._v("method")]), _vm._v(". Bacon characterizes philosophers as spiders who do not create new knowledge but only restructure the old, and contemporary scientists as ants who collect knowledge but lack the overall picture. The ideal mode of inquiry is that of bees, who both collect knowledge and structure it ("), _c('i', [_vm._v("New Organon")]), _vm._v(", 128). Bacon goes on to argue that instead of seeking valid proofs through deductive syllogisms, we should employ induction, which progressively directs us nearer the truth. Other instruments that Bacon introduces are communal inquiry, which is able to correct the mistakes of individual scientists—and offer spiritual and moral renewal ("), _c('i', [_vm._v("Great Instauration")]), _vm._v(", 74–75).")]), _c('a', {
    attrs: {
      "id": "fn70"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn70"
    }
  }, [_vm._v("70")])]), _vm._v(" Bacon points out that sinful affections and intentions caused both the fall of humanity and angels, producing such effects as lust for power, fame, and profit, and the prideful desire for knowledge, which cause us to fall under the influence of the idols.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("René Descartes")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Echoing Bacon’s sentiments, René Descartes (1596–1650) tells in his "), _c('i', [_vm._v("Discourse on the Method")]), _vm._v(" how he had dedicated his life to the pursuit of knowledge since his childhood. He studied in the best universities of his time and absorbed everything he could in all branches of science. The result, however, was confusion. He expresses his skeptical conclusion especially regarding philosophy: “Philosophy has been pursued for many centuries by the best minds, and yet everything in it is still disputed and hence doubtful; and I wasn’t so arrogant as to hope to achieve more in philosophy than others had "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("done. . . . I had no confidence in any of philosophy’s ‘results’ or in my ability to improve that situation” ("), _c('i', [_vm._v("Discourse on the Method")]), _vm._v(" 1).")]), _c('a', {
    attrs: {
      "id": "fn71"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn71"
    }
  }, [_vm._v("71")])]), _vm._v(" Descartes describes his journeys across Europe at some length, all of which points toward cynicism. Nevertheless, he observes that the buildings designed and constructed by multiple architects exhibit “less perfection” and that those made by one person are “finer and better organized.” This observation does not, of course, pertain only to the field of architecture. “I believe that if Sparta was at one time very flourishing, this wasn’t because each of its laws was good (seeing that many were very strange and even contrary to good morals), but because they were devised by a single man and hence were all conducive to the same end” ("), _c('i', [_vm._v("Discourse on the Method")]), _vm._v(" 2). Instead of consulting the multitude of philosophers, Descartes suggests, we are better off pursuing the truth by ourselves, guided by our reason ("), _c('i', [_vm._v("Discourse on the Method")]), _vm._v(" 4)."), _c('a', {
    attrs: {
      "id": "fn72"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn72"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("From here, Descartes presents his famous method of doubt, which follows four simple principles. First, we should not accept anything as true unless we are sure that it is evidently true, which means there is no way in which we can imagine having made a mistake. The words Descartes uses here are “clear and distinct,” which he explains more thoroughly elsewhere ("), _c('i', [_vm._v("Principles of Philosophy")]), _vm._v(" 1.45–46)."), _c('a', {
    attrs: {
      "id": "fn73"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn73"
    }
  }, [_vm._v("73")])]), _vm._v(" In effect, “clear” ("), _c('i', [_vm._v("clara")]), _vm._v(") means something that is seen in bright daylight, and \"distinct\" ("), _c('i', [_vm._v("distincta")]), _vm._v(") is something that we cannot mistake for something else. The latter term illustrates his second principle, in which problems are divided into smaller parts so that they might be easier to solve. The third principle requires particular order that proceeds from easier questions toward more complicated ones. Fourth, the inquirer should aim at the largest possible scope so that nothing is overlooked or forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Descartes insists that these principles for his method of doubt should not be taken to imply skepticism or vain sophism but a sincere desire to know the truth. Famously, the surest thing is one’s own existence: “Observing that this truth I am thinking, therefore I exist was so firm and sure that not even the most extravagant suppositions of the skeptics could shake it, "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I decided that I could accept it without scruple as the first principle of the philosophy I was seeking” ("), _c('i', [_vm._v("Discourse on the Method")]), _vm._v(" 4). The acuity of this perception is ultimately guaranteed by the perfect being, God, who cannot create a human being and then let him or her be led astray. Therefore we can take our perceptions as true accounts of our own existence, and consequently the structure of the world.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("What lies behind this account of human nature and our access to knowledge? Peter Harrison has argued that Descartes’s theory of knowledge is broadly Thomistic.")]), _c('a', {
    attrs: {
      "id": "fn74"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn74"
    }
  }, [_vm._v("74")])]), _vm._v(" Descartes was introduced to the principles of Thomism, which had started to gain momentum at the time, during his studies at La Flèche. Along these lines, human reason and the skills of judgment are not seriously corrupted by the fall. Instead, “our opinions differ not because some of us are more reasonable than others, but solely because we take our thoughts along different paths and don’t attend to the same things” ("), _c('i', [_vm._v("Discourse on the Method")]), _vm._v(" 1). If we form diverse opinions it is only because we lack proper methodology, not because we are corrupted. We simply need to be told how to use our reason. Descartes’s view of human knowledge is therefore optimistic. Because of our lofty status, we have, at least in principle, access to the “Adamic science,” the prelapsarian perfect knowledge of nature. Harrison, however, notes that this optimistic view was not widely welcomed. In an atmosphere where Reformers’ critique of worldly wisdom and philosophy were gaining popularity, this optimism was received with suspicion."), _c('a', {
    attrs: {
      "id": "fn75"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn75"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s04"
    }
  }, [_vm._v("1.4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("From Natural War to Perpetual Peace: Hobbes, Locke, and Kant")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Thomas Hobbes")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In "), _c('i', [_vm._v("Leviathan")]), _vm._v(", Thomas Hobbes (1588–1679) famously states, “Hereby it is manifest, that during the time men live without a common power to keep them all in awe, they are in that condition which is called war; and such a war, as is of every man, against every man” (8)."), _c('a', {
    attrs: {
      "id": "fn76"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn76"
    }
  }, [_vm._v("76")])]), _vm._v(" In this “state of nature” where no government exists, human life is “solitary, poor, nasty, brutish, "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("and short” (13). This is the background against which Hobbes builds his own proposal for a more functional human society, the commonwealth.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It is natural for humans to disagree, because their desires cause them to pursue things in ways that reveal their poor judgment skills. For example, Hobbes thinks that blind-spot bias is widespread in humanity: “For such is the nature of men that howsoever they may acknowledge many others to be more witty, or more eloquent, or more learned, yet they will hardly believe there be many so wise as themselves; for they see their own wit at hand, and other men’s at a distance” (8). Despite all kinds of individual deficits and whims, virtually every human being values life over death. This universal self-preservation, when combined with poor judgment, creates the state of nature.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("But it is not just human will that causes us to disagree; it is the use of language. Hobbes was a radical nominalist: he did not believe that there are universal essences behind words. The names of things are mere conventions, and are attributed to objects by human will. This pertains also to central ethical notions such as “good” and “evil.”")]), _c('a', {
    attrs: {
      "id": "fn77"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn77"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("But whatsoever is the object of any man’s appetite or desire; that is it, which he for his part calleth good: and the object of his hate, and aversion, evil; and of his contempt, vile and inconsiderable. For these words of good, evil, and contemptible, are ever used with relation to the person that useth them: there being nothing simply and absolutely so; nor any common rule of good and evil, to be taken from the nature of the objects themselves; but from the person of the man (where there is no commonwealth;) or, (in a commonwealth,) from the person that representeth it; or from an arbitrator or judge, whom men disagreeing shall by consent set up, and make his sentence the rule thereof. (6)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Now we can observe the central problem Hobbes attributes to the pluralism he saw emerging in his time. Because disagreements go to the root of our language, which is controlled by will without anything to check against it, it is futile to hope that disagreements could be solved by discussion and reason.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hobbes’s absolutist solution is well known. Given the state of human "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("nature, the rational thing to do is to submit oneself to the rule of the absolute sovereign one, who by his absolute power guarantees that everyone follows the law, even when it goes against one’s immediate self-interest (18). The word "), _c('i', [_vm._v("absolute")]), _vm._v(" needs to be taken here in its strictest possible sense. Namely, if the sovereign does not have "), _c('i', [_vm._v("everything")]), _vm._v(" in his hands, then power has been delegated to lower levels, which naturally and necessarily creates the possibility of disagreement (18). Under the sovereign’s rule, there is no room for dissent “because the major part hath by consenting voices declared a sovereign, he that dissented must now consent with the rest; that is, be contented to avow all the actions he shall do, or else justly be destroyed by the rest” (18).")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Hobbes’s solution to religious disagreement is straightforward. The sovereign has the power to define the form and content of spirituality, and everyone else must follow his lead in their public practice. This means that everyone must stay loyal to official state religion in public, while in their minds and in private they may disagree with it (42).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Hobbes’s theory is an interesting mix of pessimism and optimism. On the one hand, humans do not easily act rationally. Contrary to Aristotle, humans are not by nature teleologically orientated to strive for higher goods and form political structures. Hobbes claims that polis is not natural but always a contingent convention, and it does not come into existence except by power. Alan Ryan argues that instead of the Aristotelian "), _c('i', [_vm._v("summum bonum")]), _vm._v(", Hobbes bows before the "), _c('i', [_vm._v("summum malum")]), _vm._v(", which he posits as the natural goal of human beings.")]), _c('a', {
    attrs: {
      "id": "fn78"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn78"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On the other hand, Hobbes’s political theory attempts to build everything on purely scientific grounds. The problem of earlier generations, for Hobbes, is that they lacked proper scientific methods. The only token of pure science is mathematics, which is now supposed to be the foundation of politics as well (5)."), _c('a', {
    attrs: {
      "id": "fn79"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn79"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("When a man reasoneth, he does nothing else but conceive a sum total, from addition of parcels; or conceive a remainder, from subtraction of one sum from another: which (if it be done by words,) is conceiving of the consequence from the names of all the parts, to the name of the whole; or from the names of the whole and one part, to the name of "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("the other part. And though in some things, (as in numbers,) besides adding and subtracting, men name other operations, as multiplying and dividing; yet they are the same; for multiplication, is but adding together of things equal; and division, but subtracting of one thing, as often as we can. These operations are not incident to numbers only, but to all manner of things that can be added together, and taken one out of another. (5)")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("The nature of this new political science is opaque in "), _c('i', [_vm._v("Leviathan")]), _vm._v(". It seems that Hobbes wishes to use utility values and decision theory to accurately define the relevant concepts, therefore offering analytic truths that function as the foundation of human reasoning. Hobbes wants his theory to be as self-­evident and irresistible as mathematical proof.")]), _c('a', {
    attrs: {
      "id": "fn80"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn80"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But why would anyone trust his or her life in the hands of a sovereign? Hobbes argues that this is required of us by the laws of nature. These laws are duties that are binding at all times and everywhere, even in cases when we haven’t consciously signed on to them (14–15). The exact argument Hobbes provides for the laws is, however, a bit obscure, and there are several different understandings of how it should work. The general line of his argument runs as follows: Everyone desires as their goal freedom from violence. The best way to achieve this goal is to follow the golden rule—“Whatsoever you require that others should do to you, that do ye to them” (14.5). Therefore this proves that the most rational thing to do is to follow the golden rule."), _c('a', {
    attrs: {
      "id": "fn81"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn81"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hobbes’s political vision is crystal clear, even if his argument for it (contrary to his wishes) is open to debate. He belongs to the tradition of theorists who claimed to be able to ground political life in the modern scientific method. Instead of the previous generation’s seemingly endless debates about metaphysics, the new method should lead us out of the philosophers’ damp dungeons and into the light."), _c('a', {
    attrs: {
      "id": "fn82"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn82"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("John Locke")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("John Locke (1632–1704) shared Hobbes’s concerns. The English Civil War (1642–1651) and Thirty Years’ War (1618–1648) in Europe were still fresh in the minds of the populace when he wrote his "), _c('i', [_vm._v("A Letter Concerning Toleration")]), _vm._v(" (1689).")]), _c('a', {
    attrs: {
      "id": "fn83"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn83"
    }
  }, [_vm._v("83")])]), _vm._v(" The Reformation had caused the collapse of religiously uniform culture, which now added an additional element to the ongoing birth process of modern nation-states. Locke’s "), _c('i', [_vm._v("Letter")]), _vm._v(" aimed to end the persecution religious communities were inflicting on one another and to find a reasonable way for the state to manage religious disagreements.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Locke approached the religious disputes from a completely different perspective than Hobbes did. In his view, Hobbes’s proposal would lead to more, not less, civil unrest. For Locke, religious disagreements were largely "), _c('i', [_vm._v("caused")]), _vm._v(" by the state, which tried to control something that cannot be controlled. Allowing more room for religious expression would eventually lead to a better outcome.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In his "), _c('i', [_vm._v("Letter")]), _vm._v(", Locke grounds his idea of toleration on the observation that people cannot change their convictions by external force because “the life and power of true religion consists in faith, faith involves believing, and no-one can just believe what someone else tells him to believe, even if he wants to.” Consequently,")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("it can’t be up to the magistrate to take care of souls, because his power consists only in outward force, whereas true and saving religion consists in the inward faith of the soul, without which nothing can be acceptable to God, and which the nature of the human mind won’t allow to be compelled by any outward force. Confiscation of goods, imprisonment, torture—nothing like that can make men change their inward judgments about things."), _c('a', {
    attrs: {
      "id": "fn84"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn84"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Locke’s "), _c('i', [_vm._v("Letter")]), _vm._v(" contains two distinct arguments for toleration. The first is based on the involuntary nature of belief. The second concerns the nature of earthly government, the magistrate, which can use only force and does not possess reliable religious expertise that could evoke our trust in its judgments regarding religious matters.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("The nature of belief formation in Locke’s theory needs further elucidation. In his "), _c('i', [_vm._v("Letter")]), _vm._v(" and in "), _c('i', [_vm._v("An Essay Concerning Human Understanding")]), _vm._v(" (1689), Locke underscores the centrality of reason in belief formation: “Reason must be our guide in everything.”")]), _c('a', {
    attrs: {
      "id": "fn85"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn85"
    }
  }, [_vm._v("85")])]), _vm._v(" The obvious question then is, If belief is involuntary, how can it be assessed by reason? Are we not responsible for our beliefs? Maria Van Der Schaar points out that Locke faces a dilemma: in order to make his case for toleration, he needs to underscore the involuntary aspect of belief. But in order to cast blame on those who believe falsehoods or otherwise use their reason lazily, belief needs to be voluntary."), _c('a', {
    attrs: {
      "id": "fn86"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn86"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Locke’s point, however, is not that we have absolutely no control over our beliefs, only that we cannot force people into believing things they have no reason to believe. In his "), _c('i', [_vm._v("Letter")]), _vm._v(", Locke points out that there are ways for changing one’s beliefs: “It is one thing to persuade, another to command; one thing to press with arguments, another with judicial rulings”; and “The only way to change men’s opinions is through light, and you can’t produce light in someone’s mind by torturing him.”"), _c('a', {
    attrs: {
      "id": "fn87"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn87"
    }
  }, [_vm._v("87")])]), _vm._v(" In his "), _c('i', [_vm._v("Essay")]), _vm._v(", Locke offers a more complete overview of belief formation, and sets its voluntary and involuntary aspects in their proper context.")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("All that is voluntary in our Knowledge, is the employing, or with-holding any of our Faculties from this or that sort of Objects, and a more, or less accurate survey of them: But they being employed, our Will hath no Power to determine the Knowledge of the Mind one way or another; that is done only by the Objects themselves, as far as they are clearly discovered."), _c('a', {
    attrs: {
      "id": "fn88"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn88"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In other words, we have power over faculties regarding which things we pay attention to and which we put out of the mind. We can choose, for example, "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("whether we enter the garden or not, but when we have passed the gates and opened our eyes we cannot but perceive the trees and flowers that grow in the garden. This relative freedom is enough to attribute personal blame if we perform cognitive actions that exhibit ignorance and error.")]), _c('a', {
    attrs: {
      "id": "fn89"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn89"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Locke’s theory, humans are born with natural reasoning capabilities, but they need education to use their cognitive faculties well."), _c('a', {
    attrs: {
      "id": "fn90"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn90"
    }
  }, [_vm._v("90")])]), _vm._v(" Typical errors that the human mind displays are, for example, not using one’s reason at all, following others rather than using one’s own judgment (conformism), resorting to emotions instead of reason, and using reason too narrowly. This last manifests itself as confirmation bias: we tend to consult only those sources that confirm our existing beliefs."), _c('a', {
    attrs: {
      "id": "fn91"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn91"
    }
  }, [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finding truth in religious matters is challenging, Locke admits, but his belief in the possibility of human reason to arrive at truth compels him to encourage us to keep looking. We will find religious truth when we use our reason as well as we can and when we believe only those things that are highly likely to be true."), _c('a', {
    attrs: {
      "id": "fn92"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn92"
    }
  }, [_vm._v("92")])]), _vm._v(" Regarding religious disagreement, Locke makes a startling claim: disagreement is not necessarily a bad thing. Conversation between diverse standpoints helps us to avoid the aforementioned mistakes in reasoning by challenging our conventions, which are not necessarily based on solid reasoning, and by offering alternative viewpoints that can improve our knowledge."), _c('a', {
    attrs: {
      "id": "fn93"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn93"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Immanuel Kant")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("For Immanuel Kant (1724–1804), Hobbes is almost right in his account of the natural state. However, Kant corrects Hobbes by claiming not that people are "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("constantly in the state of war but that there is always a "), _c('i', [_vm._v("chance")]), _vm._v(" of war.")]), _c('a', {
    attrs: {
      "id": "fn94"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn94"
    }
  }, [_vm._v("94")])]), _vm._v(" There are pure spatial reasons behind this: people feel that they have rights to particular property or conduct. The natural way to deal with disagreements is to spread out, but we soon realize that we cannot expand endlessly. Therefore we need some rules to help determine how to live in the same space so that we can avoid war but still maintain our fundamental rights as human beings."), _c('a', {
    attrs: {
      "id": "fn95"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn95"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Kant observed that disagreements have to do mostly with things that people strive for in order to become happy and satisfied. Traditional philosophy, in Kant’s mind, could not settle this problem. As Simone Chambers states, “Kant thought that that disagreement reflected the fact that there were no universal truths about happiness except for the completely empty principle that everyone wants it.”"), _c('a', {
    attrs: {
      "id": "fn96"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn96"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The only way to prevent this fundamental disagreement from developing into a conflict is to establish a state that in many ways is similar to Hobbes’s. In a commonwealth, each citizen retains their fundamental rights and freedoms without the fear that others might take away these freedoms. The state, in contrast, is built on the following three principles. First, every citizen should act so that they do not treat others as means to some further goal, such as personal gain or pleasure. Second, every citizen is equal; they have the same rights as all other citizens. The ruler is excused, however, as they have the right to coerce the subjects without their being coerced in return. Third, every citizen has an equal right to act as a co-legislator. In a commonwealth, laws are merely a reflection of the general will of the people. In the case of disagreements (which are inevitable), the minority position must yield to the will of the majority. This principle of yielding, however, must be accepted unanimously because it is the very basis on which the commonwealth is constructed."), _c('a', {
    attrs: {
      "id": "fn97"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn97"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("From here, the conversation about the possibility to resist the ruler or sovereign emerges naturally. On the surface, there does not seem to be any "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("fundamental difference between Hobbes and Kant: they both rule out the possibility of revolt. Kant, however, leaves room for dissent. In "), _c('i', [_vm._v("Critique of Pure Reason")]), _vm._v(" he claims that “reason has no dictatorial authority: its verdict is always simply the agreement of free citizens, of whom each one must be permitted to express, without let or hindrance, his objections or even his veto.”")]), _c('a', {
    attrs: {
      "id": "fn98"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn98"
    }
  }, [_vm._v("98")])]), _vm._v(" The people have the right and freedom to express their views, but their role is limited to making arguments in the public arena. If they want to change things, they should do so through public persuasion. This freedom of expression guarantees that the state acts and rules justly. Reasoning is thus a communal matter for Kant. To quote Onora O’Neill: “By Kant’s own standards we will not reason or even think correctly unless we think in common with others.”"), _c('a', {
    attrs: {
      "id": "fn99"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn99"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Kant’s thinking is driven by his optimistic hope concerning the development of the human race. People may not yet be rational, but we are progressing toward that end."), _c('a', {
    attrs: {
      "id": "fn100"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn100"
    }
  }, [_vm._v("100")])]), _vm._v(" One of the factors Kant perceived to be a cause of strife is religion. In "), _c('i', [_vm._v("Religion within the Bounds of Reason Alone")]), _vm._v(", he remarks how ecclesial creeds naturally create a division between orthodox and heretic."), _c('a', {
    attrs: {
      "id": "fn101"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn101"
    }
  }, [_vm._v("101")])]), _vm._v(" His vision of reasonable religion would survive without these distinctions and thereby decrease the likelihood of conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#s05"
    }
  }, [_vm._v("1.5."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Beyond Enlightenment: Nietzsche, Hamann, and Contemporary Voices")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The project of Enlightenment started out as an attempt to root out uncertainty and disagreement. Ironically, the original optimistic belief in reason "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("was immediately contested, and it soon fragmented to various camps and ideologies that had very little to do with each other.")]), _c('a', {
    attrs: {
      "id": "fn102"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn102"
    }
  }, [_vm._v("102")])]), _vm._v(" Nevertheless, the demand of reason is alive and well in contemporary culture, where it takes both sophisticated and naive forms. Alasdair MacIntyre, a vocal contemporary critic of the Enlightenment, points out the performative failure of the Enlightenment’s central ideals.")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Notice then that it is not just in its inability to provide rationally justifiable and agreed moral values and principles that the Enlightenment and its heirs have failed. The failure of those modern institutions that have been the embodiment of the best social and political hopes of the Enlightenment is quite as striking. And those institutions fail by Enlightenment standards. For they do not provide—in fact they render impossible—the kinds of institutionalized reading, talking and arguing public necessary for effective practical rational thought about just those principles and decisions involved in answering such questions as: “How is a human life to be valued?” or “What does accountability in our social relationships require of us?” or “Whom, if anyone, may I legitimately deceive?”—questions to which we need shared answers. And there is no type of institutional arena in our society in which plain persons—not academic philosophers or academic political theorists—are able to engage together in systematic reasoned debate designed to arrive at a rationally well-founded common mind on these matters, a common mind which might then be given political expression. Indeed the dominant forms of organization of contemporary social life militate against the coming into existence of this type of institutional arena. And so do the dominant modes of what passes for political discourse. We do not have the kinds of reading public necessary to sustain practically effective social thought."), _c('a', {
    attrs: {
      "id": "fn103"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn103"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Even if some may see MacIntyre’s evaluation as too pessimistic, there have been philosophers who have criticized the Enlightenment from the start. The problems MacIntyre articulates did not go unnoticed among Enlightenment contemporaries.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("Friedrich Nietzsche")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Nietzsche had very little patience for philosophies that aimed for consensus by means of reason or the sovereign’s absolute power. One of his central contributions to epistemic theorization is his notion of perspectivism, which has had an enormous influence, especially in postmodern philosophy. Unsurprisingly, what Nietzsche meant is not beyond debate, and there are several perspectives from which to approach his perspectivism.")]), _c('a', {
    attrs: {
      "id": "fn104"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn104"
    }
  }, [_vm._v("104")])]), _vm._v(" But it is best to start with Nietzsche’s own claims. In "), _c('i', [_vm._v("Genealogy of Morals")]), _vm._v(", he makes the following assertion:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Precisely because we are people who seek knowledge, we should finally not be ungrateful for such determined reversals of customary perspectives and evaluations with which the spirit has for so long raged against itself with such apparent wickedness and futility. To use this for once to see differently, the will to see things differently, is no small discipline and preparation of the intellect for its coming “objectivity”—the latter meant not in the sense of “disinterested contemplation” (which is inconceivable nonsense), but as the capability of having power over one’s positive and negative arguments and of raising them and disposing of them so that one knows how to make the very variety of perspectives and interpretations of emotions useful for knowledge. From now on, my philosophical gentlemen, let us protect ourselves better from the dangerous old conceptual fantasy which posits a “pure, will-less, painless, timeless subject of cognition”; let’s guard ourselves against the tentacles of such contradictory ideas as “pure reason,” “absolute spirituality,” “knowledge in itself”—those things which demand that we think of an eye which simply cannot be imagined, an eye which is to have no direction at all, in which the active and interpretative forces are supposed to stop or "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("be absent—the very things through which seeing first becomes seeing something. Hence, these things always demand from the eye something conceptually absurd and incomprehensible. The only seeing we have is seeing from a perspective; the only knowledge we have is knowledge from a perspective; and the more emotions we allow to be expressed in words concerning something, the more eyes, different eyes, we know how to train on the same thing, the more complete our “idea” of this thing, our “objectivity,” will be. But to eliminate the will in general, to suspend all our emotions without exception—even if we were capable of that—what would that be? Wouldn’t we call that castrating the intellect?")]), _c('a', {
    attrs: {
      "id": "fn105"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn105"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("To summarize, perspectivism means denial of simple foundationalism: there are no indubitable, universally shared foundations on which to build our claims of knowledge. Everything is based on contextual and contingent claims, which receive their justification from that very moment and situation where they take place. This is a broadly antifoundationalist position."), _c('a', {
    attrs: {
      "id": "fn106"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn106"
    }
  }, [_vm._v("106")])]), _vm._v(" According to Brian Leiter, the typical account of Nietzsche’s perspectivism is formulated along the following lines:"), _c('a', {
    attrs: {
      "id": "fn107"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn107"
    }
  }, [_vm._v("107")])])]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("(i)")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v("the world has no determinate nature or structure;")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("(ii)")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v("our concepts and theories do not describe or correspond to this world because it has no determinate character;")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("(iii)")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v("our concepts and theories are mere interpretations or mere perspectives (reflecting our pragmatic needs, at least on some accounts); and")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v("(iv)")]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v("no perspective can enjoy an epistemic privilege over any other, because there is no epistemically privileged mode of access to the characterless world.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Leiter points out that a great number of scholars read Nietzsche through the lenses of this "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("received view.")]), _c('a', {
    attrs: {
      "id": "fn108"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn108"
    }
  }, [_vm._v("108")])]), _vm._v(" Furthermore, Reinhard Hütter argues that this received view has been taken as “an unexamined yet normative” account in contemporary humanities."), _c('a', {
    attrs: {
      "id": "fn109"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn109"
    }
  }, [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What does Nietzsche have to say about the conflict of opinions, then? The question is especially interesting with regard to Nietzsche’s philosophical theory and practice since he, on the one hand, seems to deny objective standpoints and, on the other hand, engages in full-scale criticisms of other standpoints. So how does he manage to do this without contradiction? Nietzsche’s perspectivism has several problems. I will follow here Bernard Reginster’s interpretation because it appears to offer the most consistent reading of Nietzsche’s own position."), _c('a', {
    attrs: {
      "id": "fn110"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn110"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Nietzsche’s perspectivism allows for so-called reasonable disagreement, where both parties are rational in holding their respective views. If they, however, wish to criticize each other, what can they do? The evident option is to engage in internal criticism. This entails that one show how the rival view is somehow incoherent by its own standards. For example, Nietzsche may wish to show how the Christian commitment to minimizing suffering does not sit well with the pursuit of truth, which often requires suffering. The point here is to show that the rejection of suffering and the commitment to truth are mutually contradictory.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Reginster correctly points out that this does not offer Nietzsche a reason to accept his own view. In other words, demonstrating inconsistency in a rival view does not yet give reason to reject the alien belief as false or accept one’s own belief as true. On perspectivism, there seems to be no way to persuade someone else of one’s own view.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, the purpose of Nietzsche’s critique can be interpreted in a variety of ways. First, he may want to urge his antagonists to become more self-reflective regarding their intellectual commitments. Second, he may want to make them reconsider their commitments. Third, he may want his critique to expose the underlying power structures of truth claims. But again, this does not say anything about the truth of the respective positions."), _c('a', {
    attrs: {
      "id": "fn111"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn111"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Johann Georg Hamann")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Johan Georg Hamann (1730–1788) is not customarily included in the Western philosophical canon. The reason behind this dismissal is a (falsely attributed) charge of irrationalism. One of the central figures in the Counter-Enlightenment, Hamann was painted as persona non grata in the higher philosophical echelons.")]), _c('a', {
    attrs: {
      "id": "fn112"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn112"
    }
  }, [_vm._v("112")])]), _vm._v(" Only recently has he received more serious academic attention, as the rationale of his thought has become more transparent.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Especially noteworthy is his relation to Nietzsche. John Betz describes him as Nietzsche’s good twin, of a sort."), _c('a', {
    attrs: {
      "id": "fn113"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn113"
    }
  }, [_vm._v("113")])]), _vm._v(" They hold almost the same beliefs but within drastically different frameworks. Nietzsche is a misotheist; Hamann is a Lutheran Christian. Both accept the perspectival nature of human knowledge, but Nietzsche believes we should never try to get beyond perspectivism to “absolute knowledge” and Hamann believes that if this happens, it is always a miracle.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Large portions of Hamann’s literary work serves as a radical alternative to Kant’s philosophy."), _c('a', {
    attrs: {
      "id": "fn114"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn114"
    }
  }, [_vm._v("114")])]), _vm._v(" Hamann observes that Kant is trying to achieve something that he cannot in all honesty achieve: to somehow get beyond language because “the indissolubility of the distance and the contingency of participation is constitutive.”"), _c('a', {
    attrs: {
      "id": "fn115"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn115"
    }
  }, [_vm._v("115")])]), _vm._v(" He admits that in human history the unity was achieved once, in the form of tower of Babel, which, in his view, was a monstrosity born out of evil desire. It achieved superficial equality, unity, and harmony, but it was maleficent from the start and, luckily, short-lived. Hamann concludes that attempts to do away with the present plurality of languages are instances merely of self-deception and forgetfulness.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“To speak is to translate,” Hamann writes, “from an angelic language to a human language, i.e. to transpose thoughts into words—things into names—images into signs.” By this cryptic progression, he joins poetry, history, and philosophy together as specific instances of the same process of "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("thought.")]), _c('a', {
    attrs: {
      "id": "fn116"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn116"
    }
  }, [_vm._v("116")])]), _vm._v(" Language, in fact, is what enables us to philosophize in the first place. All philosophies have histories (including Kant’s). Consequently, asking for reasons in some particular situation is only a subset of asking what the spoken language is."), _c('a', {
    attrs: {
      "id": "fn117"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn117"
    }
  }, [_vm._v("117")])]), _vm._v(" According to Oswald Bayer, “The various languages and reasons are not systems that would harmoniously interplay, be variously joined, or happily subordinated to each other. Hearing and understanding, speaking and being understood occur in the intersecting of various perspectives, in the rivalry of various prejudices, the conflict of various languages.”"), _c('a', {
    attrs: {
      "id": "fn118"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn118"
    }
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In other words, Hamann considers disagreement to be a noncontingent feature of our fallen world. Attempts to remove the plurality (if successful) are either acts of violence or of miracles. Ultimately, the only case where disunity was undone was at the moment of the incarnation, when the eternal divine nature assumed the form of man and became vulnerable. This is an eschatological icon through which we can observe a reality where disunity is overcome without violence, something that we can occasionally experience in this life but never in its full extent.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Contemporary Voices")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In contemporary Western societies, we cannot avoid discussing themes that would have seemed totally foreign and even peculiar to our culture not long ago. The Western mind-set is to a large extent consensual, but the reaching of consensus seems increasingly more difficult as the plurality of views and practices within them grows. In his book "), _c('i', [_vm._v("Political Liberalism")]), _vm._v(", John Rawls described the situation this way: “A modern democratic society is characterized not simply by a pluralism of comprehensive religious, philosophical, and moral doctrines but by a pluralism of incompatible yet reasonable comprehensive doctrines. No one of these doctrines is affirmed by citizens generally. Nor should one expect that in the foreseeable future one of them, or some other reasonable doctrine, will ever be affirmed by all, or nearly all, citizens.”"), _c('a', {
    attrs: {
      "id": "fn119"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn119"
    }
  }, [_vm._v("119")])]), _vm._v(" Ironically, when the Renaissance and Enlightenment thinkers formulated their views about human nature and reasonability, they thought "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("that removing authoritative hierarchies would bring about a harmonious state. Exactly the opposite ensued. In Rawls’s mind, it is the "), _c('i', [_vm._v("freedom")]), _vm._v(" of late modern society that produces more and more options from which people can choose their worldviews and values. The freer people are, the more room they have for disagreement.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("After the Enlightenment, reason has been a fundamental feature of Western thought. Today, however, no concept is more widely contested and disputed than reason.")]), _c('a', {
    attrs: {
      "id": "fn120"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn120"
    }
  }, [_vm._v("120")])]), _vm._v(" This is due partly to the acknowledgment of the "), _c('i', [_vm._v("histories")]), _vm._v(" of our ways of reasoning, underlined by Nietzsche and Hamann, and picked up in various forms by postmodern theorists. The postmodern turn solidified the earlier historicist and antiessentialist ontologies, and made reference to abstract and universal reason if not impossible, at least much more difficult. There was nothing new in this new postmodern condition, however, as it only made visible the preexisting diversity and rehabilitated certain ancient forms of thought that we explored at the beginning of this chapter. The surplus of reasonabilities has been present since the beginning of Western civilization.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Interestingly, this has led to a strange dichotomy: in contemporary Western culture, reason is at the same time adored and distrusted."), _c('a', {
    attrs: {
      "id": "fn121"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn121"
    }
  }, [_vm._v("121")])]), _vm._v(" On the one hand, reason has been attacked in academia by postmodernists who see it as a tool of oppression. On the other hand, we now have scientistic atheists and naturalists who think that hard science is able to provide us with all the necessary answers humans need to live flourishing lives. Never in the history of humanity have we seen such a variety of intellectual stances, which are also gaining support outside senior common rooms.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This disagreement has created heated debate about the role of religion, or for that matter any comprehensive tradition or doctrine, in public life. “Comprehensive doctrine” is Rawls’s term; it denotes a particular set of beliefs that give form to a clearly distinguishable intellectual form of life. Modern Western society’s problem, according to Rawls and many so-called liberal democrats, is the plurality and mutual exclusivity of these "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("doctrines. In the following, I will briefly introduce the main moves in this debate.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Liberal democrats typically believe that political actions should be based on neutral and generally agreed-on principles, which, according to Rawls, “all citizens can reasonably be expected to endorse in the light of their common human reason.”")]), _c('a', {
    attrs: {
      "id": "fn122"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn122"
    }
  }, [_vm._v("122")])]), _vm._v(" Liberal democrats differ on how easily we can access these reasons. If for Locke and Hobbes this was relatively uncomplicated, contemporary theorists admit that one needs to put quite a lot of effort into finding these principles. Virtually no one believes that these values are self-evident and immediately accessible to all and shared by all.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The typical solution offered by liberal democrats is that even if people cannot at the moment agree on central principles, in the idealized state they could."), _c('a', {
    attrs: {
      "id": "fn123"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn123"
    }
  }, [_vm._v("123")])]), _vm._v(" This means in effect that those who cannot agree are moved outside the camp and told that in a possible ideal world they would agree with the rest, but because they have some defect they cannot reach this higher knowledge at the moment. Even if this is the way modern democracy works, it sounds patronizing to many ears.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Several political philosophers from various ideological backgrounds have pointed out the problems of liberal democracy. First, it seems to place a unique burden on those whose values and actions are motivated by religion or minority ideology. Second, the epistemology on which liberal democracy is grounded gives a highly reductionistic picture of how human beliefs are formed. We do not reason like computers; our convictions are always part of the larger network of presuppositions, making it virtually impossible to draw a distinction between “religious” and “nonreligious” reasons."), _c('a', {
    attrs: {
      "id": "fn124"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn124"
    }
  }, [_vm._v("124")])]), _vm._v(" Third, many movements and arguments now seen as part of the liberal democratic tradition were originally motivated by religion—and many of them still are, as it has been shown to be quite challenging to offer nonmetaphysical arguments for human uniqueness and dignity, for "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("example.")]), _c('a', {
    attrs: {
      "id": "fn125"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn125"
    }
  }, [_vm._v("125")])]), _vm._v(" Fourth, the exclusionist strategy may be counterproductive if it builds tension between groups and causes resentment among outsiders."), _c('a', {
    attrs: {
      "id": "fn126"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn126"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This pessimistic vision is one of the factors behind the postmodern turn in political philosophy. The contemporary Western postmodern condition has made this quest for common ground more strenuous. Yet even without any influence from postmodern philosophy, it is possible to be skeptical regarding the Enlightenment project. If, for example, philosophers disagree about almost every possible detail in their own field, how can we expect them to come up with a shared concept of justice? This principle has been in the making for a long time, but consensus is nowhere in sight. This is the weak point highlighted by MacIntyrean critics. Commenting on the idea of “public reason,” which is supposed to work as the basis for liberal-democratic decision-making, Nicholas Wolterstorff points out that our idea of public reason contains contradictory principles, even when religious principles are excluded."), _c('a', {
    attrs: {
      "id": "fn127"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn127"
    }
  }, [_vm._v("127")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Among others, Richard Rorty has been one of the central figures in contemporary social philosophy who has employed broadly Nietzschean antifoundationalism in public life. Rorty admits that we do not have non-­neutral viewpoints from which to argue our case. In his view, employing arguments that refer to culturally transcendent notions and universally shared principles smacks of fundamentalism, which can take both religious and scientistic forms."), _c('a', {
    attrs: {
      "id": "fn128"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn128"
    }
  }, [_vm._v("128")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A particularly interesting feature of Rorty’s thought is that religion cannot be criticized on epistemic grounds but instead must be viewed as a political phenomenon."), _c('a', {
    attrs: {
      "id": "fn129"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn129"
    }
  }, [_vm._v("129")])]), _vm._v(" Especially in his later writings, Rorty acknowledges that religious views should be taken more seriously in the public sphere. This marks a minor shift in his views, as he had earlier defined religion as a “conversation-stopper”: the discussion ends at the very moment a religiously "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("warranted opinion is offered. In his mature vision he slightly rescinds his earlier views and seems to offer a new hope for extending the conversation among both secularists and religious:")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('p', {
    staticClass: "EX"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Instead of saying that religion was a conversation-stopper, I should have simply said that citizens of a democracy should try to put off invoking conversation-stoppers as long as possible. We should do our best to keep the conversation going without citing unarguable first principles, either philosophical or religious. If we are sometimes driven to such citation, we should see ourselves as having failed, not as having triumphed.")]), _c('a', {
    attrs: {
      "id": "fn130"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn130"
    }
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This passage reflects perfectly Rorty’s general epistemic stance: disagreements should not be approached from the viewpoint of objective reasons and arguments but from the idea of solidarity. But Rorty is not an uncritical friend of religion. In fact, his relation to religion is highly selective and ultimately not far removed from aggressive secularism. Even if he cannot be included in the New Atheist canon, he wants to limit religion completely to the private sphere. Rorty thinks that in the private sphere religion (to be precise: liberal Protestantism) may have a positive role for human flourishing, but he perceives ecclesial institutions as illegitimate users of political power, which should be done away with. At most, religions should be tolerated while we await the moment when they finally die away and secularism prevails. The goal is secular, but the means of secularization are only slightly more humane than those of Lenin and Mao."), _c('a', {
    attrs: {
      "id": "fn131"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn131"
    }
  }, [_vm._v("131")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most interesting feature in Rorty’s theory regarding the problem of religious arguments in the public sphere is not that religion is epistemically suspect but that it is not generally shared. This puts Rorty in a strange position, which has not escaped his critics. Rorty, who is known for his Enlightenment criticism, adopts public reason policy when he deals with religion."), _c('a', {
    attrs: {
      "id": "fn132"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn132"
    }
  }, [_vm._v("132")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Wolterstorff, as one of these critics, locates the disagreement between himself and Rorty (and public reason theorists) in their conflicting ideas on how to frame the ideal of liberal democracy. Wolterstorff believes “it is the genius of liberal democracy to guarantee certain basic rights and liberties to its citizens and resident aliens, and to assure access by all normal adults to fair voting procedures. Given that basic framework, it accepts all ‘comprehensive "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("perspectives’—to use Rawls’ term—as they come.”")]), _c('a', {
    attrs: {
      "id": "fn133"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn133"
    }
  }, [_vm._v("133")])]), _vm._v(" This “equal voice” model does not enforce any "), _c('i', [_vm._v("a priori")]), _vm._v(" rules of reasonability: “It doesn’t tell anybody that they have to shape up.”"), _c('a', {
    attrs: {
      "id": "fn134"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn134"
    }
  }, [_vm._v("134")])]), _vm._v(" When, after discussions, we vote, the results will naturally make some people happy and others unhappy, and sometimes the roles are reversed. This may cause frustration, but “a liberal democracy survives as long as those who lose the vote think it’s better to lose the vote than destroy the system.”"), _c('a', {
    attrs: {
      "id": "fn135"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn135"
    }
  }, [_vm._v("135")])]), _vm._v(" We simply cannot do any better.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In comparison, Rorty’s idea is not only a method but also an ideology. For Rorty, the raison d’être of democratic institutions is “making possible the invention of new forms of human freedom, taking liberties never taken before.”"), _c('a', {
    attrs: {
      "id": "fn136"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn136"
    }
  }, [_vm._v("136")])]), _vm._v(" In other words, Rortian democracy is not about ensuring the conviviality of different viewpoints but the emancipation of individual freedoms. How is this supposed to take place? The solution resembles that which has been offered by public-reason liberals: exclusion. In his writings, Rorty often adopts a condescending tone when dealing with those with whom he disagrees. But this flows smoothly from his philosophy, where disagreements are not epistemic but political. If opponents cannot be rebutted, they can only be ridiculed."), _c('a', {
    attrs: {
      "id": "fn137"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn137"
    }
  }, [_vm._v("137")])]), _vm._v(" So much for solidarity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Wolterstorff has a different tone. Letting all have their say and use the arguments they wish can be taxing, but it manifests “requisite virtues.” Eventually it will teach people to understand what they can say and how they should form arguments to convince others. Wolterstorff quotes Rorty against Rorty to underline his basic attitude toward other voices: “Moral decisions that are to be enforced by a pluralist and democratic state’s monopoly of "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("violence are best made by public discussion in which voices claiming to be God’s, or reason’s, or science’s, are put on a par with everybody’s else’s.”")]), _c('a', {
    attrs: {
      "id": "fn138"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn138"
    }
  }, [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To summarize some essential aspects of this glance at the history of philosophy, I wish to emphasize the reasons people give to the reality of disagreement and the respective cures offered. At the very least, we can identify the causes and cures listed in table 1.")]), _vm._v(" "), _c('p', {
    staticClass: "Table-Title",
    attrs: {
      "id": "t1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/list#rt1"
    }
  }, [_vm._v("Table 1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Theological and philosophical reasons for disagreement and suggested cures")])])]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td4"
  }, [_c('b', [_vm._v("Reason for disagreement")])]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_c('b', [_vm._v("Suggested cure")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v("will: corrupted love (sin)")]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_vm._v("spiritual renewal")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v("will: weakness of will")]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_vm._v("the better exercise of mental faculties")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v("reason: wrong metaphysical views")]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_vm._v("adopting a better philosophy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v("reason: wrong order of goods")]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_vm._v("spiritual renewal")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v("reason: lack of method")]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_vm._v("adopting a better method")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v("world: the truth is not readily available to us")]), _vm._v(" "), _c('td', {
    staticClass: "td5"
  }, [_vm._v("acknowledging the inevitability of disagreement")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td4a"
  }, [_vm._v("God’s action: purposeful creation of ambiguous state")]), _vm._v(" "), _c('td', {
    staticClass: "td5a"
  }, [_vm._v("humility")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Several thinkers can be linked with more than one of the aforementioned cause-cure pairs, and not all of them are mutually exclusive. The greatest difference among the philosophers lies in their belief in the possibility of overcoming our disagreement: some are more optimistic, while others are more pessimistic. At this point, the list merely illustrates the variety of views and the lack of consensus. Next, we change our perspective from history to the human mind and our lived reality.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". KRS 293–95; A. H. Coxon, "), _c('i', [_vm._v("The Fragments of Parmenides")]), _vm._v(" (Assen: Van Gorcum, 1986), 193–226.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". It is part of our post-Enlightenment methodological mind-set that it is easy for us to treat various disagreements within certain boundaries. For example, we discuss disagreement within epistemology so that it does not have immediate bearing on our political or metaphysical convictions. In ancient philosophy and medieval scholasticism, however, the different aspects of philosophy were more tightly connected. In this philosophical style it is impossible to separate metaphysics from epistemology, and these two from political philosophy. This explains why the ancients were more prone to give holistic explanations to disagreements (such as humanity’s corruption), whereas moderns tend to refer to the lack of method.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". KRS 211.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". KRS 212.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". For pre-Socratic philosophers, the problem of perception was the central issue in epistemology. See Anthony Kenny, "), _c('i', [_vm._v("A New History of Western Philosophy")]), _vm._v(" (Oxford: Oxford University Press, 2011), 118–29.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". Plato, "), _c('i', [_vm._v("Republic")]), _vm._v(" 475–80; "), _c('i', [_vm._v("Symposium")]), _vm._v(" 210e–211a. See also Nicholas White, “Plato’s Metaphysical Epistemology,” in "), _c('i', [_vm._v("The Cambridge Companion to Plato")]), _vm._v(", ed. Richard Kraut (Cambridge: Cambridge University Press, 1992), 277–310.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". Also in "), _c('i', [_vm._v("Euthyphro")]), _vm._v(" (8a), Plato acknowledges that in more mundane cases you can always “resort to a weighing machine,” but wonders how you measure values when “people regard the same things, some as just and others as unjust,—about these they dispute; and so there arise wars and fightings among them.” And, of course, the problem is not only with people but also with gods who disapprove and approve of the same things. Here it is also important to note Plato’s general distaste for rhetoric and the negative influence it has on democratic decision making. This comes to the fore in other dialogues as well. See, e.g., "), _c('i', [_vm._v("Gorgias")]), _vm._v(", "), _c('i', [_vm._v("Symposium")]), _vm._v(", and "), _c('i', [_vm._v("Phaedrus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8"
    }
  }, [_vm._v("8")]), _vm._v(". Plato, "), _c('i', [_vm._v("Phaedrus")]), _vm._v(", in "), _c('i', [_vm._v("The Dialogues of Plato")]), _vm._v(", trans. Benjamin Jowett, 3rd ed. (New York: Oxford University Press, 1892), 263a–b.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9"
    }
  }, [_vm._v("9")]), _vm._v(". The method of collection and division proceeds as follows. If, for example, we judge a thing to be both good and bad, we are in effect conflating two different objects and basing our judgment on the conflated entity. Instead, we need to make a correct distinction between particular objects and our dispositions. See Nicholas P. White, "), _c('i', [_vm._v("Plato on Knowledge and Reality")]), _vm._v(" (Indianapolis: Hackett, 1976), 122. In the conclusion of the dialogue, Socrates states: “Until a man knows the truth of the several particulars of which he is writing or speaking, and is able to define them as they are, and having defined them again to divide them until they can be no longer divided, and until in like manner he is able to discern the nature of the soul, and discover the different modes of discourse which are adapted to different natures, and to arrange and dispose them in such a way that the simple form of speech may be addressed to the simpler nature, and the complex and composite to the more complex nature—until he has accomplished all this, he will be unable to handle arguments according to rules of art, as far as their nature allows them to be subjected to art, either for the purpose of teaching or persuading—such is the view implied in the preceding argument.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10"
    }
  }, [_vm._v("10")]), _vm._v(". White, “Plato’s Metaphysical Epistemology,” 297. For examples, see "), _c('i', [_vm._v("Republic")]), _vm._v(" 583b–586e; "), _c('i', [_vm._v("Theatetus")]), _vm._v(" 170a–c.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11"
    }
  }, [_vm._v("11")]), _vm._v(". Plato, "), _c('i', [_vm._v("Republic")]), _vm._v(" 431a.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12"
    }
  }, [_vm._v("12")]), _vm._v(". Plato, "), _c('i', [_vm._v("Republic")]), _vm._v(" 409b.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13"
    }
  }, [_vm._v("13")]), _vm._v(". And his opinion becomes even grimmer in his later dialogues. Although the "), _c('i', [_vm._v("Republic")]), _vm._v(" is taken to be Plato’s major political work, his belief in the possibility of good rule by philosopher-kings diminishes in his later thought and is replaced by immutable laws, formulated by philosophers. See "), _c('i', [_vm._v("Laws")]), _vm._v(" 874e–875d. See also George Klosko, “Plato’s Political Philosophy,” in "), _c('i', [_vm._v("The Routledge Companion to Social and Political Philosophy")]), _vm._v(", ed. Gerald Gaus and Fred D’Agostino (London: Routledge, 2013), 10–12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14"
    }
  }, [_vm._v("14")]), _vm._v(". Martha Nussbaum, "), _c('i', [_vm._v("The Fragility of Goodness: Luck and Ethics in Greek Tragedy and Philosophy")]), _vm._v(" (Cambridge: Cambridge University Press, 1986), 160.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15"
    }
  }, [_vm._v("15")]), _vm._v(". Jason Xenasis (“Plato on Ethical Disagreement,” "), _c('i', [_vm._v("Phronesis")]), _vm._v(" 1 [1955], 50–57) has suggested that Plato offers a hierarchy of criteria, which helps navigate among different judgments. In "), _c('i', [_vm._v("Philebus")]), _vm._v(" 66a–c, there appears a set of desiderata in which five goods appear in a particular order. These are, first, right measure and moderation; second, beauty and adequateness; third, practical wisdom; fourth, science and skills; and finally, “painless” pleasures. Xenasis argues that the Platonic hierarchy is superior to “horizontal” commandments, such as the Decalogue, where all commandments have equal value and can thus mutually contradict each other. However, one must ask, do not the vertical and hierarchical systems suffer from different kinds of problems? In our technological age, why should we favor practical reason or beauty over effectiveness? Who tells us which one of two beautiful things is more desirable? What is the correct measure of moderation, and so on?")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16"
    }
  }, [_vm._v("16")]), _vm._v(". Plato, "), _c('i', [_vm._v("Republic")]), _vm._v(" 591e–592b; 520b–d.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17"
    }
  }, [_vm._v("17")]), _vm._v(". Aristotle, "), _c('i', [_vm._v("Nicomachean Ethics")]), _vm._v(" 1102a26–1103a1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18"
    }
  }, [_vm._v("18")]), _vm._v(". 1139a22–35.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19"
    }
  }, [_vm._v("19")]), _vm._v(". Aristotle, "), _c('i', [_vm._v("De anima")]), _vm._v(", trans. D. W. Hamlyn (Oxford: Clarendon, 1968), 424a17–a20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20"
    }
  }, [_vm._v("20")]), _vm._v(". The Greek word "), _c('i', [_vm._v("eidos")]), _vm._v(" can be translated both as “species” and “form.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21"
    }
  }, [_vm._v("21")]), _vm._v(". See Leen Spruit, "), _c('i', [_vm._v("Species Intelligibilis: From Perception to Knowledge")]), _vm._v(", vol. 1, "), _c('i', [_vm._v("Classical Roots and Medieval Discussions")]), _vm._v(" (Leiden: Brill, 1994), 37–38, 45–46. Aristotle, "), _c('i', [_vm._v("De anima")]), _vm._v(" 429a13–17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22"
    }
  }, [_vm._v("22")]), _vm._v(". See, e.g., Ekaterina Haskins, “Endoxa, Epistemological Optimism, and Aristotle’s Rhetorical Project,” "), _c('i', [_vm._v("Philosophy and Rhetoric")]), _vm._v(" 37 (2004).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23"
    }
  }, [_vm._v("23")]), _vm._v(". Aristotle, "), _c('i', [_vm._v("Nicomachean Ethics")]), _vm._v(", trans. J. A. K. Thomson (London: Penguin, 1955), 1145b2–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24"
    }
  }, [_vm._v("24")]), _vm._v(". Aristotle, "), _c('i', [_vm._v("Nicomachean Ethics")]), _vm._v(" 1154a22–25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn25"
    }
  }, [_vm._v("25")]), _vm._v(". Nicholas Denyer, "), _c('i', [_vm._v("Language, Thought and Falsehood in Ancient Greek Philosophy")]), _vm._v(" (London: Routledge, 1990), 210.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn26"
    }
  }, [_vm._v("26")]), _vm._v(". Haskins, “Endoxa, Epistemological Optimism, and Aristotle’s Rhetorical Project,” 5–6.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn27"
    }
  }, [_vm._v("27")]), _vm._v(". Nussbaum, "), _c('i', [_vm._v("Fragility of Goodness")]), _vm._v(", 261; Carrie-Ann Biondi Khan, “Aristotle’s Moral Expert: The "), _c('i', [_vm._v("Phronimos")]), _vm._v(",” in "), _c('i', [_vm._v("Ethics Expertise: History, Contemporary Perspectives and Applications")]), _vm._v(", ed. Lisa Rasmussen (Dordrecht: Springer, 2005), 39–53.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn28"
    }
  }, [_vm._v("28")]), _vm._v(". Aristotle, "), _c('i', [_vm._v("Topics")]), _vm._v(", 100b20. Quoted from Aristotle, "), _c('i', [_vm._v("Introductory Readings")]), _vm._v(", trans. Terence Irwin (Indianapolis: Hackett Publishing, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn29"
    }
  }, [_vm._v("29")]), _vm._v(". Aristotle, "), _c('i', [_vm._v("Politics")]), _vm._v(", trans. Benjamin Jowett (Blacksburg: Virginia Tech, 2001), 1261a1–34: “We ought not to attain this greatest unity even if we could, for it would be the destruction of the state. Again, a state is not made up only of so many men, but of different kinds of men.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn30"
    }
  }, [_vm._v("30")]), _vm._v(". Aristotle, "), _c('i', [_vm._v("Politics")]), _vm._v(" 1267a4–5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn31"
    }
  }, [_vm._v("31")]), _vm._v(". See, e.g., Augustine, "), _c('i', [_vm._v("Civ.")]), _vm._v(" 4.8–32; 8.1–4. Augustine’s account of Socrates in "), _c('i', [_vm._v("Civ.")]), _vm._v(" 8.3 is illustrative: “Both in his life and in his death, Socrates left very many disciples of his philosophy, who vied with one another in desire for proficiency in handling those moral questions which concern the chief good ["), _c('i', [_vm._v("summum bonum")]), _vm._v("], the possession of which can make a man blessed; and because, in the disputations of Socrates, where he raises all manner of questions, makes assertions, and then demolishes them, it did not evidently appear what he held to be the chief good, every one took from these disputations what pleased him best, and every one placed the final good in whatever it appeared to himself to consist. Now, that which is called the final good is that at which, when one has arrived, he is blessed. But so diverse were the opinions held by those followers of Socrates concerning this final good, that (a thing scarcely to be credited with respect to the followers of one master) some placed the chief good in pleasure, as Aristippus, others in virtue, as Antisthenes. Indeed, it were tedious to recount the various opinions of various disciples” (all translations of "), _c('i', [_vm._v("De civitate Dei")]), _vm._v(" are from Augustine, "), _c('i', [_vm._v("The City of God")]), _vm._v(", in "), _c('i', [_vm._v("A Select Library of Nicene and Post-Nicene Fathers of the Church")]), _vm._v(", vol. 2, series 1, "), _c('i', [_vm._v("St. Augustin’s “City of God” and “Christian Doctrine,”")]), _vm._v(" ed. Philip Schaff, trans. Marcus Dods [1886–1889; repr., Peabody, MA: Hendrickson, 1994]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn32"
    }
  }, [_vm._v("32")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Acad.")]), _vm._v(" 151. An example of philosophical skepticism was Sextus Empiricus (fl. second/third century), whose "), _c('i', [_vm._v("Outlines of Pyrrhonism")]), _vm._v(" has had a significant impact in later Western philosophy, especially during the Renaissance, when his works were rediscovered. Sextus suggests that for every philosophical point argued, one can find equally good reasons to oppose it. Therefore one should not form beliefs about matters that are contested in this way, but should suspend one’s judgment. This leads to tranquility ("), _c('i', [_vm._v("ataraxia")]), _vm._v("), which frees the person from troubling thoughts and consequent anxiety. On Augustine and the skeptical tradition, see Phillip Cary, "), _c('i', [_vm._v("Outward Signs: The Powerlessness of External Things in Augustine’s Thought")]), _vm._v(" (Oxford: Oxford University Press, 2008), 39–55.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn33"
    }
  }, [_vm._v("33")]), _vm._v(". Paul J. Griffiths, “How Reasoning Goes Wrong: A Quasi-Augustinian Account of Error and Its Implications,” in "), _c('i', [_vm._v("Reason and the Reasons of Faith")]), _vm._v(", ed. Paul J. Griffiths and Reinhard Hütter (New York: T&T Clark, 2005), 145–59.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn34"
    }
  }, [_vm._v("34")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Enchir.")]), _vm._v(" 5.17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn35"
    }
  }, [_vm._v("35")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Catech")]), _vm._v(". 3. See Cary, "), _c('i', [_vm._v("Outward Signs")]), _vm._v(", 11.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn36"
    }
  }, [_vm._v("36")]), _vm._v(". Cary, "), _c('i', [_vm._v("Outward Signs")]), _vm._v(", 102–5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn37"
    }
  }, [_vm._v("37")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Doctr. chr.")]), _vm._v(" 2.1–15. Numbering and all translations for "), _c('i', [_vm._v("De doctrina Christiana")]), _vm._v(" are from Saint Augustine, "), _c('i', [_vm._v("On Christian Teaching")]), _vm._v(", trans. R. P. H. Green (Oxford: Oxford University Press, 1997).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn38"
    }
  }, [_vm._v("38")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Doctr. chr.")]), _vm._v(" 2.3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn39"
    }
  }, [_vm._v("39")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Doctr. chr.")]), _vm._v(" 2.8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn40"
    }
  }, [_vm._v("40")]), _vm._v(". "), _c('i', [_vm._v("Doctr. chr.")]), _vm._v(" 2.10. Augustine also makes similar claims in "), _c('i', [_vm._v("Doctr. chr.")]), _vm._v(" 4.27; "), _c('i', [_vm._v("Ep")]), _vm._v(". 55.11.21; "), _c('i', [_vm._v("Ep")]), _vm._v(". 137.18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn41"
    }
  }, [_vm._v("41")]), _vm._v(". For a detailed treatment, see Luigi Gioia, "), _c('i', [_vm._v("The Theological Epistemology of Augustine’s “De Trinitate”")]), _vm._v(" (Oxford: Oxford University Press, 2008), 190–218; John Rist, “Faith and Reason,” in "), _c('i', [_vm._v("The Cambridge Companion to Augustine")]), _vm._v(", ed. Norman Kretzman and Eleonore Stump (Cambridge: Cambridge University Press, 2001), 32–37; Risto Saarinen, "), _c('i', [_vm._v("Weakness of the Will in Medieval Thought: From Augustine to Buridan")]), _vm._v(" (Leiden: Brill, 1994), 20–43; Timo Nisula, "), _c('i', [_vm._v("Augustine and the Functions of Concupiscence")]), _vm._v(" (Leiden: Brill, 2012).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn42"
    }
  }, [_vm._v("42")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Civ.")]), _vm._v(" 19.24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn43"
    }
  }, [_vm._v("43")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Confessions")]), _vm._v(", trans. Albert C. Outler (1955; repr., New York:Barnes & Noble Classics, 2007), 4.15.25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn44"
    }
  }, [_vm._v("44")]), _vm._v(". For a brief exposition on how will functions in the decision-making process, see Griffiths, “How Reasoning Goes Wrong,” 154–57.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn45"
    }
  }, [_vm._v("45")]), _vm._v(". For detailed, and various, accounts of Augustine’s political vision, see Eric Gregory, "), _c('i', [_vm._v("Politics and the Order of Love")]), _vm._v(" (Chicago: University of Chicago Press, 2010), 75–125, 363–84; Charles Mathewes, "), _c('i', [_vm._v("A Theology of Public Life")]), _vm._v(", Cambridge Studies in Christian Doctrine (Cambridge: Cambridge University Press, 2008); Phillip Cary, “United Inwardly by Love: Augustine’s Social Ontology,” in "), _c('i', [_vm._v("Augustine and Politics")]), _vm._v(", ed. John Doody, Kevin L. Hughes, and Kim Paffenroth (Lanham, MD: Lexington, 2004), 3–33; John Milbank, "), _c('i', [_vm._v("Theology and Social Theory")]), _vm._v(" (Oxford: Blackwell, 1990), 389–92; Nicholas Wolterstorff, "), _c('i', [_vm._v("The Mighty and the Almighty: An Essay in Political Theology")]), _vm._v(" (Cambridge: Cambridge University Press, 2012), 35–46.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn46"
    }
  }, [_vm._v("46")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Doctr. chr.")]), _vm._v(" 4.139–40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn47"
    }
  }, [_vm._v("47")]), _vm._v(". See the first ten books of "), _c('i', [_vm._v("De civitate Dei")]), _vm._v(", as well as "), _c('i', [_vm._v("Civ.")]), _vm._v(" 18.1. However, Augustine rejects metaphysical dualism. See "), _c('i', [_vm._v("Civ.")]), _vm._v(" 4.15.24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn48"
    }
  }, [_vm._v("48")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Civ.")]), _vm._v(" 18.2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn49"
    }
  }, [_vm._v("49")]), _vm._v(". Cary, “Inwardly United,” 30–33. Augustine, "), _c('i', [_vm._v("Civ.")]), _vm._v(" 15.4: “But the things which this city desires cannot justly be said to be evil, for it is itself, in its own kind, better than all other human good. For it desires earthly peace for the sake of enjoying earthly goods, and it makes war in order to attain to this peace; since, if it has conquered, and there remains no one to resist it, it enjoys a peace which it had not while there were opposing parties who contested for the enjoyment of those things which were too small to satisfy both. This peace is purchased by toilsome wars; it is obtained by what they style a glorious victory.” See also "), _c('i', [_vm._v("Civ.")]), _vm._v(" 19.12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn50"
    }
  }, [_vm._v("50")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Civ.")]), _vm._v(" 19.17: “Even the heavenly city, therefore, while in its state of pilgrimage, avails itself of the peace of earth, and, so far as it can without injuring faith and godliness, desires and maintains a common agreement among men regarding the acquisition of the necessaries of life, and makes this earthly peace bear upon the peace of heaven; for this alone can be truly called and esteemed the peace of the reasonable creatures, consisting as it does in the perfectly ordered and harmonious enjoyment of God and of one another in God. When we shall have reached that peace, this mortal life shall give place to one that is eternal, and our body shall be no more this animal body which by its corruption weighs down the soul, but a spiritual body feeling no want, and in all its members subjected to the will.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn51"
    }
  }, [_vm._v("51")]), _vm._v(". "), _c('i', [_vm._v("ST")]), _vm._v(" I.82.2; 85.6 See also Eleonore Stump, "), _c('i', [_vm._v("Aquinas")]), _vm._v(" (London: Routledge, 2013), 233. Jean Porter, "), _c('i', [_vm._v("Nature as Reason")]), _vm._v(" (Grand Rapids: Eerdmans, 2005), 255–57; Alasdair MacIntyre, “Aquinas and the Extent of Moral Disagreement,” in "), _c('i', [_vm._v("Selected Essays")]), _vm._v(", vol. 2, "), _c('i', [_vm._v("Ethics and Politics")]), _vm._v(" (Cambridge: Cambridge University Press, 2006), 64–84.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn52"
    }
  }, [_vm._v("52")]), _vm._v(". In "), _c('i', [_vm._v("ST")]), _vm._v(" I.82. Aquinas still has intellectualist emphasis: intellect is able to move the will as its final cause. Later in "), _c('i', [_vm._v("ST")]), _vm._v(" I-II.9.1 intellect appears as a formal cause, that is to say, it merely presents objects to the will. This moves Aquinas in a more voluntaristic direction. See Reinhard Hütter, “The Directedness of Reasoning and the Metaphysics of Creation,” in Griffiths and Hütter, "), _c('i', [_vm._v("Reason and the Reasons of Faith")]), _vm._v(", 174–76; Stump, "), _c('i', [_vm._v("Aquinas")]), _vm._v(", 289–90.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn53"
    }
  }, [_vm._v("53")]), _vm._v(". For an extensive treatment of various cases of conflict, see Daniel McInerny, "), _c('i', [_vm._v("The Difficult Good: A Thomistic Approach to Moral Conflict and Human Happiness")]), _vm._v(" (New York: Fordham University Press, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn54"
    }
  }, [_vm._v("54")]), _vm._v(". "), _c('i', [_vm._v("ST")]), _vm._v(" I-II.2.94.2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn55"
    }
  }, [_vm._v("55")]), _vm._v(". Scott MacDonald, “Theory of Knowledge,” in "), _c('i', [_vm._v("The Cambridge Companion to Aquinas")]), _vm._v(", ed. Norman Kretzman and Eleonore Stump (Cambridge: Cambridge University Press, 1993), 178. "), _c('i', [_vm._v("PA")]), _vm._v(" 1.5.7. “To clarify this division it should be noted that any proposition whose predicate is included within the notion of its subject is immediate and known in virtue of itself as it stands. However, in the case of some of these propositions the terms are such that they are understood by everyone, as "), _c('i', [_vm._v("being")]), _vm._v(" and "), _c('i', [_vm._v("one")]), _vm._v(" and those other notions that are characteristic of being precisely as being: for "), _c('i', [_vm._v("being")]), _vm._v(" is the first concept in the intellect. Hence it is necessary that propositions of this kind be held as known in virtue of themselves not only as they stand but also in reference to us. Examples of these are the propositions that ‘It does not occur that the same thing is and is not,’ and that ‘The whole is greater than its part,’ and others like these. Hence all the sciences take principles of this kind from metaphysics, whose task it is to consider being absolutely and the characteristics of being. On the other hand, there are some immediate propositions whose terms are not known by everyone. Hence, although their predicate may be included in the very notion of their subject, yet because the definition of the subject is not known to everyone, it is not necessary that such propositions be conceded by everyone. (Thus the proposition, ‘All right angles are equal,’ is in itself a proposition which is immediate and known in virtue of itself, because equality appears in the definition of a right angle. For a right angle is one which a straight line forms when it meets another straight line in such a way that the angles on each side are equal.) Therefore, such principles are received as being posited or laid down” (translation from Thomas Aquinas, "), _c('i', [_vm._v("Commentary on the “Posterior Analytics” of Aristotle")]), _vm._v(", trans. Fabian R. Larcher, OP [Albany, NY: Magi Books, 1970]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn56"
    }
  }, [_vm._v("56")]), _vm._v(". It is well known that medieval schools and individual thinkers occasionally disagreed with each other. Novel views or those that contradicted prevailing orthodoxy were typically treated with iron gloves. For a good overview on how differing views were handled in general, see Robert Pasnau, "), _c('i', [_vm._v("Metaphysical Themes, 1274–1671")]), _vm._v(" (New York: Oxford University Press, 2011), 428–58. One clear exception was Nicholas of Autrecourt’s "), _c('i', [_vm._v("Tractatus")]), _vm._v(", which tried to lay out some rules on how to deal with disagreements. Pasnau explains ("), _c('i', [_vm._v("Metaphysical Themes")]), _vm._v(", 447–48): “[Autrecourt’s] first step is to offer a general rule for the conditions under which it is permissible to offer a new doctrine that clashes with the majority view. The rule is that if someone grasps all the concepts pertinent to some question as well as does the majority, and also clearly grasps further concepts that permit one to see more into the truth of that question, then one can ‘without presumption’ and ‘with sufficient certitude’ reach conclusions contrary to the majority. As an example he describes how the majority of young men abandon the intellectual virtues in pursuit of riches, honors, and carnal pleasures. What is one to do in the light of how the majority conduct themselves? Should one reason that the majority is likely to know best? Of course not—instead, one should follow the rule just described, and reason that one sees perfectly well what the attraction of these sensual pleasures is, and has further concepts as well, regarding ‘the good that lies in the contemplation of God and in the use of the moral virtues.’ This makes it permissible to ignore the masses, and follow one’s own, superior judgment. Autrecourt quickly clarifies that he does not mean to apply this rule to himself: he claims no such superiority in grasping philosophical concepts. But there is a second rule that applies to his own case. If someone develops unorthodox ideas in some domain, and if that person discusses these ideas with others of good judgment, and if that person deliberates for a long time about these ideas, and they continue to seem correct, ‘then he can and should—especially in merely speculative matters—reveal faithfully his view and set out his claims [not] as true, but so that his view may be considered in light of these claims.’” However, Autrecourt’s advice was not well received, and in 1347 he was required to burn his writings.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn57"
    }
  }, [_vm._v("57")]), _vm._v(". This list is given by Hütter (“Directedness of Reasoning,” 180–82), who comments here on "), _c('i', [_vm._v("ST")]), _vm._v(" II-II.167.1 (On Curiosity).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn58"
    }
  }, [_vm._v("58")]), _vm._v(". "), _c('i', [_vm._v("ST")]), _vm._v(" II-II.167.Resp.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn59"
    }
  }, [_vm._v("59")]), _vm._v(". Aquinas, however, thinks that people who do not have faith are able to perform genuine virtues, whereas Augustine thinks that pagan virtues are only splendid vices. Augustine thus has the more pessimistic view of human performance than Aquinas. For discussion, see Jennifer Herdt, "), _c('i', [_vm._v("Putting on Virtue: The Legacy of the Splendid Vices")]), _vm._v(" (Chicago: University of Chicago Press, 2008).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn60"
    }
  }, [_vm._v("60")]), _vm._v(". Alasdair MacIntyre, “Philosophy Recalled to Its Tasks: A Thomistic Reading of ‘Fides et Ratio,’” in "), _c('i', [_vm._v("Selected Essays")]), _vm._v(", vol. 1, "), _c('i', [_vm._v("The Tasks of Philosophy")]), _vm._v(" (Cambridge: Cambridge University Press, 2006), 180–82. See also MacIntyre, "), _c('i', [_vm._v("God, Philosophy, Universities: A Selective History of the Catholic Philosophical Tradition")]), _vm._v(" (London: Continuum, 2009), 175.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn61"
    }
  }, [_vm._v("61")]), _vm._v(". Given that Aquinas’s theory of knowledge is so optimistic, Stump ("), _c('i', [_vm._v("Aquinas")]), _vm._v(", 234) argues that “error, deception, and false opinion have to be explained as either guilt or punishment.” In the original state, Adam could not err (and thus there could be no disagreements either). After the fall, disagreement can be seen as a form of punishment.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn62"
    }
  }, [_vm._v("62")]), _vm._v(". "), _c('i', [_vm._v("ST")]), _vm._v(" Ia-Iae.94.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn63"
    }
  }, [_vm._v("63")]), _vm._v(". MacIntyre, “Aquinas,” 65–67.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn64"
    }
  }, [_vm._v("64")]), _vm._v(". "), _c('i', [_vm._v("ST")]), _vm._v(" I-II.2. Of course, Aquinas denies that these are genuine definitions of happiness, even if they can be regarded as good things per se if they are in proper relation to the ultimate good.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn65"
    }
  }, [_vm._v("65")]), _vm._v(". MacIntyre, “Aquinas,” 71.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn66"
    }
  }, [_vm._v("66")]), _vm._v(". Aquinas himself does not offer a single solution for how to solve actual disagreement. Instead, depending on the case, disagreements should be solved by individuals’ own judgment, or by rulers or ecclesial authority’s command.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn67"
    }
  }, [_vm._v("67")]), _vm._v(". Bacon’s "), _c('i', [_vm._v("Advancement of Learning")]), _vm._v(" (1605), however, is an earlier and more comprehensive (yet less known) vision than "), _c('i', [_vm._v("Organon")]), _vm._v(", and the first major work in which he lays out the outline for the renewal of science and philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn68"
    }
  }, [_vm._v("68")]), _vm._v(". Francis Bacon, "), _c('i', [_vm._v("The Great Instauration")]), _vm._v(", in "), _c('i', [_vm._v("Selected Philosophical Works")]), _vm._v(", ed. Rose-Mary Sargent (Indianapolis: Hackett, 1999), 66. All following in-text references in this section are page numbers to this edition.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn69"
    }
  }, [_vm._v("69")]), _vm._v(". Bacon, "), _c('i', [_vm._v("Selected Philosophical Writings")]), _vm._v(". See also Peter Harrison, “Original Sin and the Problem of Knowledge in Early Modern Europe,” "), _c('i', [_vm._v("Journal of the History of Ideas")]), _vm._v(" 63 (2002): 171–72.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn70"
    }
  }, [_vm._v("70")]), _vm._v(". Bacon’s utopian work "), _c('i', [_vm._v("New Atlantis")]), _vm._v(" tells about a perfect island, where both technology and moral spiritual virtues are practiced in harmony. See Stephen A. McKnight, “Religion and Francis Bacon’s Scientific Utopianism,” "), _c('i', [_vm._v("Zygon")]), _vm._v(" 42 (2007): 463–86.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn71"
    }
  }, [_vm._v("71")]), _vm._v(". In-text references are from René Descartes, "), _c('i', [_vm._v("Discourse on the Method of Rightly Conducting One’s Reason and Seeking Truth in the Sciences")]), _vm._v(", trans. Jonathan Bennett, Some Texts from Early Modern Philosophy, last revised 2007, "), _c('a', {
    attrs: {
      "href": "http://earlymoderntexts.com/assets/pdfs/descartes1637.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://earlymoderntexts.com/assets/pdfs/descartes1637.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn72"
    }
  }, [_vm._v("72")]), _vm._v(". “We ought never to let ourselves be convinced except by the evidentness of our reason.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn73"
    }
  }, [_vm._v("73")]), _vm._v(". See "), _c('i', [_vm._v("Principles of Philosophy")]), _vm._v(", trans. Jonathan Bennett, Some Texts from Early Modern Philosophy, last revised 2012, "), _c('a', {
    attrs: {
      "href": "http://earlymoderntexts.com/assets/pdfs/descartes1644.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://earlymoderntexts.com/assets/pdfs/descartes1644.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn74"
    }
  }, [_vm._v("74")]), _vm._v(". Harrison, “Original Sin and the Problem of Knowledge,” 246–47.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn75"
    }
  }, [_vm._v("75")]), _vm._v(". Peter Harrison, "), _c('i', [_vm._v("Fall of Man and the Foundations of Science")]), _vm._v(" (Cambridge: Cambridge University Press, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn76"
    }
  }, [_vm._v("76")]), _vm._v(". In-text references are to section numbers in Thomas Hobbes, "), _c('i', [_vm._v("Leviathan")]), _vm._v(", ed. J. C. A. Gaskin (Oxford: Oxford University Press, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn77"
    }
  }, [_vm._v("77")]), _vm._v(". For a thorough treatment, see Philip Pettit, "), _c('i', [_vm._v("Made with Words: Hobbes on Language, Mind, and Politics")]), _vm._v(" (Princeton: Princeton University Press, 2008); Simone Chambers, “Who Shall Judge? Hobbes, Locke and Kant on the Construction of Public Reason,” "), _c('i', [_vm._v("Ethics and Global Politics")]), _vm._v(" 2, no. 4 (2009): 349–68.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn78"
    }
  }, [_vm._v("78")]), _vm._v(". Alan Ryan, “Hobbes’s Political Philosophy,” in "), _c('i', [_vm._v("The Cambridge Companion to Hobbes")]), _vm._v(", ed. Tom Sorell (Cambridge: Cambridge University Press, 1996), 216–17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn79"
    }
  }, [_vm._v("79")]), _vm._v(". See also Tom Sorell, “The Science in Hobbes’s Politics,” in "), _c('i', [_vm._v("Perspectives on Thomas Hobbes")]), _vm._v(", ed. G. A. J. Rogers and Alan Ryan (Oxford: Clarendon, 1998), 67–80.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn80"
    }
  }, [_vm._v("80")]), _vm._v(". Emmanuel Ugwudi Eze ("), _c('i', [_vm._v("On Reason: Rationality in a World of Cultural Conflict and Racism")]), _vm._v(" [Durham: Duke University Press, 2008], 28–32, [31]) colorfully defines this hoped-for result as “an epistemological slam dunk.” Interestingly, Hobbes disregarded arts and literature because they corrupt the culture and manifest mere irrationality.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn81"
    }
  }, [_vm._v("81")]), _vm._v(". S. A. Lloyd, “Hobbes,” in "), _c('i', [_vm._v("The Routledge Companion to Social and Political Philosophy")]), _vm._v(", ed. Gerald Gaus and Fred D’Agostino (New York: Routledge, 2013), 65–66.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn82"
    }
  }, [_vm._v("82")]), _vm._v(". "), _c('i', [_vm._v("Leviathan")]), _vm._v(" contains a chapter (46, “Of Darkness from Vain Philosophy and Fabulous Traditions”) that resembles Bacon’s account of idols. Here, Hobbes turns his criticisms against the philosophy of the ancient Greeks, claiming, “Their moral philosophy is but a description of their own passions. . . . They make the rules of good and bad by their own liking and disliking; by which means, in so great diversity of taste, there is nothing generally agreed on; but every one doth, as far as he dares, whatsoever seemeth good in his own eyes, to the subversion of Commonwealth.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn83"
    }
  }, [_vm._v("83")]), _vm._v(". John Wiedhoft Gough, “The Development of Locke’s Belief in Toleration,” in "), _c('i', [_vm._v("John Locke, “A Letter Concerning Toleration” in Focus")]), _vm._v(", ed. John Horton and Susan Mendus (London: Routledge, 1991), 57–77.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn84"
    }
  }, [_vm._v("84")]), _vm._v(". John Locke, "), _c('i', [_vm._v("A Letter Concerning Toleration")]), _vm._v(", ed. Jonathan Bennett, Some Texts from Early Modern Philosophy, 2010, 2, "), _c('a', {
    attrs: {
      "href": "http://earlymoderntexts.com/assets/pdfs/locke1689b.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://earlymoderntexts.com/assets/pdfs/locke1689b.pdf")]), _vm._v(" (numbered references to Locke’s "), _c('i', [_vm._v("Letter")]), _vm._v(" are to section number).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn85"
    }
  }, [_vm._v("85")]), _vm._v(". John Locke, "), _c('i', [_vm._v("An Essay Concerning Human Understanding")]), _vm._v(" (New York: Dover, 1959), 4.19.14.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn86"
    }
  }, [_vm._v("86")]), _vm._v(". Maria Van Der Schaar, “Locke on Judgment and Religious Toleration,” "), _c('i', [_vm._v("British Journal for the History of Philosophy")]), _vm._v(" 20, no. 1 (2012): 46–47.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn87"
    }
  }, [_vm._v("87")]), _vm._v(". Locke, "), _c('i', [_vm._v("Letter")]), _vm._v(" 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn88"
    }
  }, [_vm._v("88")]), _vm._v(". Locke, "), _c('i', [_vm._v("Essay")]), _vm._v(" 4.13.2. See also Van Der Schaar, “Locke on Judgment and Religious Toleration,” 48–50.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn89"
    }
  }, [_vm._v("89")]), _vm._v(". Locke, "), _c('i', [_vm._v("Essay")]), _vm._v(" 4.20.16. In modern political discourse, tolerance and relativism are usually taken to be part of the same package. Contemporary tolerance is to a large extent motivated by skepticism about the possibilities of reasonable conversation. This is not the case with Locke, as he thinks that tolerance and disagreement can help us to achieve the truth. Additionally, tolerance is not based on the equality of all truth claims but on individuals’ right to judge religious matters by themselves, not relying on external authorities. Thus, e.g., Adam Wolfson, “Toleration and Relativism: The Locke-Proast Exchange,” "), _c('i', [_vm._v("Review of Politics")]), _vm._v(" 59 (1997): 213–31.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn90"
    }
  }, [_vm._v("90")]), _vm._v(". See, e.g., John Locke, "), _c('i', [_vm._v("Some Thoughts Concerning Education")]), _vm._v(", ed. John W. Yolton and Jean S. Yolton (Oxford: Clarendon, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn91"
    }
  }, [_vm._v("91")]), _vm._v(". Locke, "), _c('i', [_vm._v("Essay")]), _vm._v(" 4.20; Van Der Schaar, “Locke on Judgment and Religious Toleration,” 55.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn92"
    }
  }, [_vm._v("92")]), _vm._v(". For an overview of Locke’s theory of knowledge, see Nicholas Wolterstorff, "), _c('i', [_vm._v("John Locke and the Ethics of Belief")]), _vm._v(", Cambridge Studies in Religion and Critical Thought (Cambridge: Cambridge University Press, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn93"
    }
  }, [_vm._v("93")]), _vm._v(". Van Der Schaar, “Locke on Judgment and Religious Toleration,” 62–65.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn94"
    }
  }, [_vm._v("94")]), _vm._v(". Immanuel Kant, "), _c('i', [_vm._v("Toward Perpetual Peace")]), _vm._v(", in "), _c('i', [_vm._v("“Toward Perpetual Peace” and Other Writings on Politics, Peace, and History")]), _vm._v(", ed. Pauline Kleingeld, trans. David L. Colclasure (New Haven: Yale University Press, 2006), app. 4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn95"
    }
  }, [_vm._v("95")]), _vm._v(". Kant, "), _c('i', [_vm._v("Toward Perpetual Peace")]), _vm._v(", app. 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn96"
    }
  }, [_vm._v("96")]), _vm._v(". Chambers, “Who Shall Judge,” 361.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn97"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn97"
    }
  }, [_vm._v("97")]), _vm._v(". John R. Goodreau, “Kant’s Contribution to the Idea of Democratic Pluralism,” in "), _c('i', [_vm._v("Reassessing the Liberal State: Reading Maritain’s “Man and the State,”")]), _vm._v(" ed. Timothy Fuller and John P. Hittinger (Washington, DC: Catholic University of America Press, 2006), 99–126. Immanuel Kant, "), _c('i', [_vm._v("Political Writings")]), _vm._v(", ed. H. S. Reiss, Cambridge Texts in the History of Political Thought (Cambridge: Cambridge University Press, 1991), 74–79.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn98"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn98"
    }
  }, [_vm._v("98")]), _vm._v(". Immanuel Kant, "), _c('i', [_vm._v("Critique of Pure Reason")]), _vm._v(", trans. Francis Haywood (London: Living Time Press, 2004), A739/B767.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn99"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn99"
    }
  }, [_vm._v("99")]), _vm._v(". Quoted in Van Der Schaar, “Locke on Judgment and Religious Toleration,” 365. Onora O’Neill, “The Public Use of Reason,” "), _c('i', [_vm._v("Political Theory")]), _vm._v(" 14, no. 4 (1986): 546.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn100"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn100"
    }
  }, [_vm._v("100")]), _vm._v(". Immanuel Kant, "), _c('i', [_vm._v("What Is Enlightenment?,")]), _vm._v(" in "), _c('i', [_vm._v("Political Writings")]), _vm._v(", 58: “If we are asked, ‘Do we now live in an enlightened age?’ the answer is, ‘No,’ but we do live in an age of enlightenment. As things now stand, much is lacking which prevents men from being, or easily becoming, capable of correctly using their own reason in religious matters with assurance and free from outside direction. But on the other hand, we have clear indications that the field has now been opened wherein men may freely deal with these things and that the obstacles to general enlightenment or the release from self-imposed tutelage are gradually being reduced. In this respect, this is the age of enlightenment, or the century of Frederick.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn101"
    }
  }, [_vm._v("101")]), _vm._v(". Immanuel Kant, "), _c('i', [_vm._v("Religion within the Bounds of Bare Reason Alone")]), _vm._v(", trans. Werner S. Pluhar (Indianapolis: Hackett, 2009), 3.5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn102"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn102"
    }
  }, [_vm._v("102")]), _vm._v(". Arthur A. Lovejoy ("), _c('i', [_vm._v("The Great Chain of Being")]), _vm._v(" [Cambridge, MA: Harvard University Press, 1978], 9) aptly describes the Enlightenment naïveté: “Assuming human nature to be a simple thing, the Enlightenment also, as a rule, assumed political and social problems to be simple, and therefore easy of solution. Rid man’s mind of a few ancient errors, purge his beliefs of the artificial complications of metaphysical ‘systems’ and theological dogmas, restore to his social relations something like the simplicity of the state of nature, and his natural excellence would, it was assumed, be realized, and mankind would live happily ever after.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn103"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn103"
    }
  }, [_vm._v("103")]), _vm._v(". Alasdair MacIntyre, “Some Enlightenment Projects Considered,” in Alasdair MacIntyre, "), _c('i', [_vm._v("Selected Essays")]), _vm._v(", vol. 2, "), _c('i', [_vm._v("Ethics and Politics")]), _vm._v(" (Cambridge: Cambridge University Press, 2006), 185.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn104"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn104"
    }
  }, [_vm._v("104")]), _vm._v(". For an overview of discussion, see Brian Leiter, “Perspectivism in Nietzsche’s "), _c('i', [_vm._v("Genealogy of Morals")]), _vm._v(",” in "), _c('i', [_vm._v("Nietzsche, Genealogy, Morality: Essays on Nietzsche’s “On the Genealogy of Morals")]), _vm._v(",” ed. Richard Schacht (Berkeley: University of California Press, 1994), 334–54.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn105"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn105"
    }
  }, [_vm._v("105")]), _vm._v(". Friedrich Nietzsche, "), _c('i', [_vm._v("On the Genealogy of Morals")]), _vm._v(", trans. Ian Johnston (Arlington, VA: Richer Resources, 2010), 3.12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn106"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn106"
    }
  }, [_vm._v("106")]), _vm._v(". Maudemarie Clark, "), _c('i', [_vm._v("Nietzsche on Truth and Philosophy")]), _vm._v(" (Cambridge: Cambridge University Press, 1990), 130.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn107"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn107"
    }
  }, [_vm._v("107")]), _vm._v(". Leiter, “Perspectivism in Nietzsche’s "), _c('i', [_vm._v("Genealogy of Morals")]), _vm._v(",” 334.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn108"
    }
  }, [_vm._v("108")]), _vm._v(". Leiter himself regards this to be an incorrect reading, and he tries to save Nietzsche from the obvious inconsistency that arises from the aforementioned tenets. The central inconsistency is between i, ii, and iv, as the two latter tenets offer a determinate description of the world. Leiter’s suggestion is to read Nietzsche as a coherentist and antirealist. However, this goes against several of Nietzsche’s own points, not least his criticisms of other views.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn109"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn109"
    }
  }, [_vm._v("109")]), _vm._v(". Hütter, “Directedness of Reasoning,” 162.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn110"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn110"
    }
  }, [_vm._v("110")]), _vm._v(". Bernard Reginster, “Perspectivism, Criticism and Freedom of Spirit,” "), _c('i', [_vm._v("European Journal of Philosophy")]), _vm._v(" 8 (2000): 40–62.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn111"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn111"
    }
  }, [_vm._v("111")]), _vm._v(". Brian Lightbody, “Nietzsche, Perspectivism, Anti-Realism: An Inconsistent Triad,” "), _c('i', [_vm._v("European Legacy")]), _vm._v(" 15, no. 4 (2010): 425–38; Reginster, “Perspectivism.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn112"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn112"
    }
  }, [_vm._v("112")]), _vm._v(". For a critical account of Hamann, see Isaiah Berlin, "), _c('i', [_vm._v("The Magus of the North: J. G. Hamann and the Origins of Modern Irrationalism")]), _vm._v(" (London: Fontana, 1994). During the Counter­-Enlightenment the criticism of Enlightenment reason was aimed at the uses of reason, which were perceived as illegitimate or even self-contradictory, not at reason as such.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn113"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn113"
    }
  }, [_vm._v("113")]), _vm._v(". John Betz, "), _c('i', [_vm._v("After Enlightenment: The Post-Secular Vision of J. G. Hamann")]), _vm._v(" (Oxford: Wiley-Blackwell, 2009), 319–26.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn114"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn114"
    }
  }, [_vm._v("114")]), _vm._v(". See especially Oswald Bayer, "), _c('i', [_vm._v("A Contemporary in Dissent: Johann Georg Hamann as a Radical Enlightener")]), _vm._v(" (Grand Rapids: Eerdmans, 2012), 156–70.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn115"
    }
  }, [_vm._v("115")]), _vm._v(". Quoted in Bayer, "), _c('i', [_vm._v("A Contemporary in Dissent")]), _vm._v(", 160.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn116"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn116"
    }
  }, [_vm._v("116")]), _vm._v(". Johann Georg Hamann, "), _c('i', [_vm._v("Aesthetica in Nuce")]), _vm._v(", in "), _c('i', [_vm._v("Writings on Philosophy and Language")]), _vm._v(", trans. Kenneth Hayes, Cambridge Texts in the History of Philosophy (Cambridge: Cambridge University Press, 2007), 66n23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn117"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn117"
    }
  }, [_vm._v("117")]), _vm._v(". Bayer, "), _c('i', [_vm._v("A Contemporary in Dissent")]), _vm._v(", 164–65.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn118"
    }
  }, [_vm._v("118")]), _vm._v(". Bayer, "), _c('i', [_vm._v("A Contemporary in Dissent")]), _vm._v(", 159.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn119"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn119"
    }
  }, [_vm._v("119")]), _vm._v(". John Rawls, "), _c('i', [_vm._v("Political Liberalism")]), _vm._v(" (New York: Columbia University Press, 1996), xviii.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn120"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn120"
    }
  }, [_vm._v("120")]), _vm._v(". The classic in this respect is, of course, Alasdair MacIntyre, "), _c('i', [_vm._v("Whose Justice? Which Rationality?")]), _vm._v(" (Notre Dame: University of Notre Dame Press, 1988). For more recent approaches, see, e.g., Robert Audi, "), _c('i', [_vm._v("The Architecture of Reason: The Structure and Substance of Rationality")]), _vm._v(" (Oxford: Oxford University Press, 2001); Emmanuel Ugwudi Eze, "), _c('i', [_vm._v("On Reason: Rationality in a World of Cultural Conflict and Racism")]), _vm._v(" (Durham: Duke University Press, 2008).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn121"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn121"
    }
  }, [_vm._v("121")]), _vm._v(". Audi, "), _c('i', [_vm._v("Rationality")]), _vm._v(", 4. See also Pope John Paul II, "), _c('i', [_vm._v("Fides et Ratio")]), _vm._v(", the Vatican website, 1998, §5, "), _c('a', {
    attrs: {
      "href": "http://w2.vatican.va/content/john-paul-ii/en/encyclicals/documents/hf_jp-ii_enc_14091998_fides-et-ratio.html",
      "target": "_blank"
    }
  }, [_vm._v("http://w2.vatican.va/content/john-paul-ii/en/encyclicals/documents/hf_jp-ii_enc_14091998_fides-et-ratio.html")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn122"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn122"
    }
  }, [_vm._v("122")]), _vm._v(". Rawls, "), _c('i', [_vm._v("Political Liberalism")]), _vm._v(", 140.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn123"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn123"
    }
  }, [_vm._v("123")]), _vm._v(". For an overview of these positions, see Nicholas Wolterstorff, "), _c('i', [_vm._v("Understanding Liberal Democracy: Essays in Political Philosophy")]), _vm._v(", ed. Terence Cuneo (Oxford: Oxford University Press, 2012), 11–40, 76–110.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn124"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn124"
    }
  }, [_vm._v("124")]), _vm._v(". Eric Gregory, “Before the Original Position: The Neo-orthodox Theology of the Young John Rawls,” "), _c('i', [_vm._v("Journal of Religious Ethics")]), _vm._v(" 35 (2007): 198. See also Jeffrey Stout, "), _c('i', [_vm._v("Democracy and Tradition")]), _vm._v(" (Princeton: Princeton University Press, 2005); John Perry, "), _c('i', [_vm._v("The Pretenses of Loyalty: Locke, Liberal Theory, and American Political Theology")]), _vm._v(" (Oxford: Oxford University Press, 2011), 17–68. Chantal Mouffe, “The Limits of John Rawls’s Pluralism,” "), _c('i', [_vm._v("Journal of International Political Theory")]), _vm._v(" 3 (2007): 109–28.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn125"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn125"
    }
  }, [_vm._v("125")]), _vm._v(". See, e.g., Raimond Gaita, "), _c('i', [_vm._v("A Common Humanity: Thinking about Love and Truth and Justice")]), _vm._v(" (London: Routledge 2000), 5; Jeff McMahan, “Challenges to Human Equality,” "), _c('i', [_vm._v("Journal of Ethics")]), _vm._v(" 12 (2008): 81–104.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn126"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn126"
    }
  }, [_vm._v("126")]), _vm._v(". Jeffrey Stout, “Folly of Secularism,” "), _c('i', [_vm._v("Journal of American Academy of Religion")]), _vm._v(" 76, no. 3 (2008): 533–44.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn127"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn127"
    }
  }, [_vm._v("127")]), _vm._v(". Wolterstorff, "), _c('i', [_vm._v("Understanding Liberal Democracy")]), _vm._v(", 27–29.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn128"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn128"
    }
  }, [_vm._v("128")]), _vm._v(". Serge Grigoriev, “Rorty, Religion and Humanism,” "), _c('i', [_vm._v("International Journal for Philosophy of Religion")]), _vm._v(" 70 (2011): 189.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn129"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn129"
    }
  }, [_vm._v("129")]), _vm._v(". Richard Rorty, “Religion in the Public Square: A Reconsideration,” "), _c('i', [_vm._v("Journal of Religious Ethics")]), _vm._v(" 31, no. 1 (2003): 142; Stephen Louthan, “On Religion—A Discussion with Richard Rorty, Alvin Plantinga and Nicholas Wolterstorff,” "), _c('i', [_vm._v("Christian Scholar’s Review")]), _vm._v(" 27, no. 2 (1996): 177–83.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn130"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn130"
    }
  }, [_vm._v("130")]), _vm._v(". Rorty, “Religion in the Public Square: A Reconsideration,” 148–49.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn131"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn131"
    }
  }, [_vm._v("131")]), _vm._v(". Thus Stout, “Folly,” 534–36.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn132"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn132"
    }
  }, [_vm._v("132")]), _vm._v(". See, e.g., Grigoriev, “Rorty,” 194–95; Wolterstorff, "), _c('i', [_vm._v("Understanding Liberal Democracy")]), _vm._v(", 44.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn133"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn133"
    }
  }, [_vm._v("133")]), _vm._v(". Wolterstorff, "), _c('i', [_vm._v("Understanding Liberal Democracy")]), _vm._v(", 50.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn134"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn134"
    }
  }, [_vm._v("134")]), _vm._v(". Wolterstorff, "), _c('i', [_vm._v("Understanding Liberal Democracy")]), _vm._v(", 50.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn135"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn135"
    }
  }, [_vm._v("135")]), _vm._v(". Wolterstorff, "), _c('i', [_vm._v("Understanding Liberal Democracy")]), _vm._v(", 50–51.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn136"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn136"
    }
  }, [_vm._v("136")]), _vm._v(". Richard Rorty, "), _c('i', [_vm._v("Philosophy and Social Hope")]), _vm._v(" (London: Penguin, 2000), 126. See also David Bentley Hart, "), _c('i', [_vm._v("The Experience of God: Being, Consciousness, Bliss")]), _vm._v(" (New Haven: Yale University Press, 2014), 312–13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn137"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn137"
    }
  }, [_vm._v("137")]), _vm._v(". See, e.g., the famous passage in Robert B. Brandom, ed., "), _c('i', [_vm._v("Rorty and His Critics")]), _vm._v(" (Oxford: Blackwell, 2000), 22: “So we are going to go right on trying to discredit you in the eyes of your children, trying to strip your fundamentalist religious community of dignity, trying to make your views seem silly rather than discussable. We are not so inclusivist as to tolerate intolerance such as yours. . . . I don’t see anything "), _c('i', [_vm._v("herrschaftsfrei")]), _vm._v(" [domination free] about my handling of my fundamentalist students. Rather, I think those students are lucky to find themselves under the benevolent "), _c('i', [_vm._v("Herrschaft")]), _vm._v(" [domination] of people like me, and to have escaped the grip of their frightening, vicious, dangerous parents. . . . I am just as provincial and contextualist as the Nazi teachers who made their students read "), _c('i', [_vm._v("Der Stürmer")]), _vm._v("; the only difference is that I serve a better cause.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn138"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn138"
    }
  }, [_vm._v("138")]), _vm._v(". Wolterstorff, "), _c('i', [_vm._v("Understanding Liberal Democracy,")]), _vm._v(" 48.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8ba322","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 81
// module chunks = 0